import './style.scss'
import React, {useEffect, useState,useContext, useRef, Children, useCallback} from 'react';
import { AppContext } from '../../context';
//import { toast } from 'react-toastify';
//import api from '../../services/api';
import { FiSearch,FiEdit2, FiPackage, FiMoreHorizontal,FiDisc } from 'react-icons/fi';
import { AiFillSetting, AiOutlineLeft } from 'react-icons/ai';
import { Bs123, BsCollectionFill, BsFillSendFill, BsLink45Deg } from 'react-icons/bs';
import throttle from 'lodash/throttle';

import ReactGA from "react-ga4";
import { apenasNumeros, floatToReal, realToFloat, safeFloat, safeInt, safeStr, strBasic, updStateJson, updStateJsonOne } from '../../services/utils';
import moment from 'moment';
import { LoadingOutlined } from '@ant-design/icons';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';


//import DatePicker from 'react-datepicker';
//import "react-datepicker/dist/react-datepicker.css";

import { InputNumber,DatePicker, Spin, Result, Switch } from 'antd';


import { Tag, Button, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import EmojiPicker from 'emoji-picker-react';

import { AiOutlineRight } from "react-icons/ai";
import { VscOpenPreview, VscFilter, VscSearch } from "react-icons/vsc";

import { format } from 'path';
import { toast } from 'react-toastify';

import { Table, Input, Tooltip  } from 'antd';
import { SearchOutlined, WhatsAppOutlined, MailOutlined, DeleteOutlined, DeleteFilled, LikeOutlined, LikeFilled ,
        CaretUpOutlined , CaretDownOutlined   } from '@ant-design/icons';
import { Alert } from 'antd';

import { Link } from 'react-router-dom';

import dayjs from 'dayjs';


import { FaBuilding, FaEquals, FaGreaterThan, FaLessThan, FaLock, FaNotEqual, FaPlus, FaPlusCircle, FaQuestionCircle, FaRegTrashAlt, FaTag, FaUser } from 'react-icons/fa';
import { FaWandMagicSparkles } from 'react-icons/fa6';
import { MdLockOutline, MdOutlineAltRoute, MdOutlineBlock, MdPhoneIphone } from 'react-icons/md';
import { ImBlocked } from 'react-icons/im';
import { GiSmartphone } from 'react-icons/gi';
import { isMobile } from 'react-device-detect';



const { Option } = Select;

export async function delay( func = () => {} , tempo=350){
    setTimeout(func, tempo);
};


export function sanString(texto) {
    const allowedChars = /[^0-9a-zA-ZáàâãéèêííóòôõúùüÁÀÂÃÉÈÊÍÍÓÒÔÕÚÙÜçÇ@$&*=#~.,;:?!()-/\\§±ªº°¨«»‘’“”„„…†‡•°—―₩₩€£¥§µ₵₽￥符号_…~…†‡•°—―₩₩€£¥§µ₵₽￥ 符号_\[\]{}<>]/g;
    return texto.replace(allowedChars, '');
  }


export function apenasValor(_string)
{                      
    let a = _string.BReplace('.','').BReplace(',','')                   
    if(a.match(/^[0-9]+$/) != null){
        return true;
    } else {
        return false;
    }
}   

export function retornaApenasNumeros(_string)
{               
    let a = String(_string).replace(/\D/g, '');                           
    return a;
}   

export function removerAcentos(_string) {
    const textoNormalizado = _string.normalize('NFD');
    return textoNormalizado.replace(/[\u0300-\u036f]/g, '');
  }


export function isObjectEmpty(obj) { // Verifica se o obj está vazio, True para vazio, false para cheio.
    if(obj == null || obj == undefined || Object.keys(obj).length === 0){ // 9788000121451
        return true;
    }else{
        let tt = String(JSON.stringify(obj));
       
        if(tt.length >= 2 && tt.length <= 8){
           
            tt = String(tt).BReplace(" ", "");
            
            if(tt == "{}" || tt == "[]" || tt == "{[]}" || tt == "[{}]" || tt == "{{}}" || tt == "[[]]" || tt == "[{{}}}"){
      
                return true;
            }else{
                return false;
            }
        }else{
            if(String(obj).length > 2){
                return false;
            }else{
                return true;
            }            
        }               
    }  
  }

  export const focusComponent = (name, sellAll=false, forca=false) => {
    if(!isMobile || forca){
        try{
            const el = document.getElementsByName(name);
            if(el.length === 1){
                el[0].focus();
                if(sellAll){
                    try{
                        el[0].select();
                    }catch{
                        return;
                    }
                }
            }
        }catch{
            alert("Objeto não encontrado!!");
        }
    }
  };


export const handleEnter = (e, next = null) => {
    if (e.key == "Enter" || e.key == "Next" || e.key == "Go" || e.key == "Okay" || e.key == "Ok" || e.key == "Alt") {
        
        if(next){
            e.preventDefault();
            focusComponent(next, true);
        }
    }

  };

export const selectComponent = (name, forca=false) => {
    if(!isMobile || forca){
        try{
            const el = document.getElementsByName(name);
            if(el.length === 1){
        
                el[0].select();
            }
        }catch{
            alert("Objeto não encontrado!");
        }
    }
};

export const focusComponentPorID = (id, sellAll=false, forca=false) => {
    if(!isMobile || forca){
        try{
            const el = document.getElementById(id);
            if(el){
                el.focus();
                if(sellAll){
                    el.select();
                }
            }
        }catch{
            alert("Objeto não encontrado!");
        }
    }
};

export const selectComponentPorID = (id) => {
    if(!isMobile){
        try{
            const el = document.getElementById(id);
            if(el){
                el.select();
            }
        }catch{
            alert("Objeto não encontrado!");
        }
    }
};

export const isFocusedComponentPorID = (id) => {
    try{
        const el = document.getElementById(id);
        if(el){
            if(el === document.activeElement){
                return true
            }
        }
    }catch{
        //-
    }
    return false
};



function randomNum(max) {
    let min = 1;
    // 👇️ get number between min (inclusive) and max (inclusive)
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function randomNumStr(max) {
    return String(randomNum(max))
  }

    export const BContext = ({ show=null, setShow=()=>{}, itens=[], icones=false, info, closeOnClick=true }) => {
        const { isMobile, isTablet } = useContext(AppContext);
        const [pos, setPos] = useState({x: 0, y: 0});

        const [topo, setTopo] = useState(false);
        const [page, setPage] = useState(1);

        const [q_itens, setQ_itens] = useState(0);


        const [subItens, setSubItens] = useState([]);
        
        useEffect(() => {
            if(topo == true){
                setTopo(false);
            }
        if(itens.length > 0){
            let q = 0;
            itens.map( e => { if(e != null && isObjectEmpty(e) == false) { 
                if(e.tipo == "TOPO"){ setTopo(true) }else{ q += 1 }
            }});
            setQ_itens(q);
        }
        

        }, [itens]);

        
        function getAltura(extra=0){
            let altura = 10;
            let tem_topo = false;
            itens.map( p => { 
                if(p != null){
                    if(p.tipo && p.tipo == "TOPO"){ 
                        tem_topo = true;
                    }else{
                        if (p.tipo && (p.tipo == "ITEM" || p.tipo == "CHECK" || p.tipo == "-")){ 
                            altura += 35
                        }
                    }        
                }
            })
            if(tem_topo){
                altura += 35
            }
            return altura + extra;
        }

        function getPosY(){
            let pos = 0;
            let y = show.clientY;
            if(getAltura(y + 30) >= window.innerHeight){
                pos = window.innerHeight - getAltura(30);
                if(pos < -10){
                    pos = 0;
                }
            }else{
                pos = y;
            } 
            return pos;
        }

        useEffect(() => {
            setPage(1);
            setSubItens([]);
            if(show != null){
            let x = show.clientX;
            let y = show.clientY;
            
            if( (x + 250) >= window.innerWidth){
                x = x - 200;
            }

            setPos({
                x: x,
                y: getPosY()
                });
            
            }else{
                
            }
        }, [show]);

        function addItem(tipo, nome ="", hint = "", click = () => {}, check, icon, disabled, subs=[], visible = true, help=""){

            function convTxIcon(_icon){
                if(_icon && String(_icon)[0] == "_"){
                    let tmp_icon = <></>
                    if(String(_icon) == "_MAGIC"){ tmp_icon = <FaWandMagicSparkles color='#717ced'/> }
                    if(String(_icon) == "_ETIQUETA"){ tmp_icon = <FaTag color='#50799e'size={18}/> }
                    if(String(_icon) == "_ENVIAR"){ tmp_icon = <BsFillSendFill color='#50799e'size={18}/> }
                    if(String(_icon) == "_MENU_CX"){ tmp_icon = <BsCollectionFill color='#50799e'size={18} /> }
                    return tmp_icon;
                }else{
                    
                    return _icon && (typeof _icon === 'function') ? _icon() : _icon;
                }
            }

            if(visible){
            if(tipo == "SUBS") {
                return(<div className={'bcontext-item '+(disabled && disabled == true ? "bcontext-disabled" : "")} 
                            onClick={()=>{ if(disabled && disabled == true){ }else{ setSubItens(subs); setPage(2); } }} 
                            style={{paddingLeft: icones ? "2px" : null, justifyContent:"space-between"}}>
                {icones ? <div style={{display:"flex", alignItems:"center"}}><div style={{width:"22px", marginRight:"4px", display:"flex", justifyContent:"center", alignItems:"center",
                                        fontSize:"20px",  }}>{icon ? convTxIcon(icon) : ""}</div>{nome}</div> : <>{nome}</>}  
                <AiOutlineRight color='black'/>
                </div>)
            }else if(tipo == "TOPO") {
                return(<div className={'bcontext-ite-topo '+(disabled && disabled == true ? "bcontext-disabled" : "")}
                            onClick={()=>{if(disabled && disabled == true){ }else{ click(); if(closeOnClick){ setShow(null) } } }} 
                            style={{paddingLeft: icones ? "2px" : null, justifyContent:"space-between"}}>
                    {<div style={{width:"22px", marginRight:"4px", display:"flex", justifyContent:"center", alignItems:"center",
                        fontSize:"20px",  }} title={nome} >{icon ? convTxIcon(icon) : nome}</div>}  
            
                </div>)
            }else if(tipo == "ITEM") {
                return(<div className={'bcontext-item '+(disabled && disabled == true ? "bcontext-disabled" : "")} 
                            onClick={()=>{ if(disabled && disabled == true){ }else{ click(); if(closeOnClick){ setShow(null) } } }} 
                            style={{paddingLeft: icones ? "2px" : null, justifyContent:"space-between"}}>
                {icones ? <div style={{display:"flex", alignItems:"center"}}>
                                <div style={{width:"22px", marginRight:"4px", display:"flex", justifyContent:"center", alignItems:"center",
                                        fontSize:"20px",  }}>{icon ? convTxIcon(icon) : ""}</div>{nome}</div> : <>{nome}</>}  
                {String(hint.length) > 0 && <div style={{fontSize:"11px", color:"rgb(55, 55, 55)", marginRight:"5px"}}>{hint}</div>}
                {String(help).length > 0 && <div><Tooltip title={String(help)} zIndex={999999}><FaQuestionCircle size={14} color={"rgb(69, 106, 121)"} style={{marginLeft:"5px"}}/></Tooltip></div> }

            
                </div>)
            }else if(tipo == "CHECK") {
                return(<div className={'bcontext-item '+(disabled && disabled == true ? "bcontext-disabled" : "")} onClick={()=>{
                    if(disabled && disabled == true){ }else{click(); if(closeOnClick){ setShow(null) } } }}>
                <BCheck titulo={nome} modelo={4} textPos='end' fundo='rgba(255, 255, 255, 0)' value={check && check == true ? true : false} 
                        setValue={()=>{}}  />
                </div>)
            }else if(tipo == "-"){
                return(<div className='bcontext-separador'/>)
            }
            }
        }


        return(<>
            { show != null && <>
            <div style={{position:"fixed",top:0,left:0, zIndex:9999, height: "100%", width:"100%"}} 
                onClick={()=> {setShow(null)}} onContextMenu={(e)=>{ e.preventDefault(); setShow(null); }}  >
            
            </div>
            <div className='bcontext-fundo' style={{top: pos.y, left: pos.x, 
           
                                                    width: (q_itens > 16 && isMobile == false ) ? "420px" : "auto" }}>
                {/*  
                border: getAltura(pos.y + 10) > window.innerHeight ? "2px solid red" : "2px solid blue",
                <p>{getAltura()} x {window.innerHeight} x { getAltura(pos.y + 10)}</p> 
                */}
                { topo == true && <>
                <div style={{ display:"flex", flexDirection:"row", height:"30px", alignItems:'center', gap:"5px" }}>
                    {   itens.map( (e, index) => { if(e != null && isObjectEmpty(e) == false) { if(e.tipo == "TOPO"){
                                return(addItem(e.tipo, e.nome, e.hint, e.click, e.check, e.icon, e.visible, e.help));
                        }}})
                    }
                </div>
                <div className='bcontext-separador'/>
                </> }
                <div style={{ display:"flex", flexDirection:"row"}}>
                    { page == 1 && <>
                        { isMobile == true ? 
                            <div className='bcontext-itens' >
                            { itens.map(( (e, index) => { if(e != null && isObjectEmpty(e) == false) {if(e.tipo != "TOPO"){
                                return(addItem(e.tipo, e.nome, e.hint, e.click, e.check, e.icon, e.disabled, e.subs, e.visible, e.help));                
                            }}})) }
                            </div>
                        : <>
                            <div className='bcontext-itens' >
                            { itens.map(( (e, index) => {  if(e != null && isObjectEmpty(e) == false) {if(index <= 16 && e.tipo != "TOPO"){
                                return(addItem(e.tipo, e.nome, e.hint, e.click, e.check, e.icon, e.disabled, e.subs, e.visible, e.help));                
                            }}})) }
                            </div>
                            { q_itens > 16 && isMobile == false &&  <>
                            <div className='bcontext-itens' style={{borderLeft:"1px solid rgb(224, 224, 224)"}} >
                                { itens.map(( (e, index) => { if(index > 16 && e.tipo != "TOPO"){
                                    return(addItem(e.tipo, e.nome, e.hint, e.click, e.check, e.icon, e.disabled, e.subs, e.visible, e.help));         
                            }})) }
                            </div>
                            </> }
                        </>}
                    </> }
                    { page == 2 && <>
                        <div className='bcontext-itens' style={{padding:"2px", }} >
                            <div className='bcontext-itens' style={{ outline:"1px solid rgb(218, 218, 218)", borderRadius: "10px", padding: "4px"}} >
                                <div className={'bcontext-item'} onClick={ () => {setPage(1)}} >
                                <AiOutlineLeft color='black' style={{marginRight:"10px"}}/> Voltar
                                </div>
                                <div className='bcontext-separador'/>
                                { subItens.map(( (e, index) => { if(e.tipo != "TOPO"){
                                    return(addItem(e.tipo, e.nome, e.hint, e.click, e.check, e.icon, e.disabled, e.subs, e.visible, e.help));                
                                }})) }
                            </div>
                        </div>
                    
                    </>}

                </div>
                    { info && String(info).length > 1 && <>
                <div className='bcontext-separador'/>
                <div style={{ display:"flex", flexDirection:"row", padding:"6px", textAlign:"center", 
                            alignItems:"center", justifyContent:"center", color:"rgb(37, 82, 121)"}}>
                <div>{info}</div> 
                {
                    /*
                    Verifique as classificações dos tributos, para que não ocorram problemas depois!
                    */
                }  
                </div>
                </>}
            </div>
            </> }
        </>)

    }

  export const BNum = ({reef, className, minWidth="52px", name, comBtn=!isMobile,bordaCor, titulo, height, hint, btnPlus, value=0, disabled, onKeyUp = () => {},
                        def, cor, modelo=1, max=1, min=1, setValue,onExit,onEnter,fontSize ,next, width="100px", pulse=true}) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);
    // DEF = valor default fontSize
    const he = titulo ? height ? "calc("+  height+" + 20px)" : "calc(26px + 20px)" : height ? height : "26px";
    const autoIDtemp = "BNum"+randomNumStr(999)+randomNumStr(99)+randomNumStr(999)+String(String(titulo).length)+randomNumStr(999)+randomNumStr(9);
    const [modoFloat, setModoFloat] = useState(String(value).includes(",") || String(value).includes("."));
    const [carregando, setCarregando] = useState(false);
    // ----------------------------
    const [ tmp, setTmp ] = useState(value);   
    useEffect(() => {
        if(value != tmp){
            setTmp(value);
        }
       // toast.success(value)
     }, [value])         
    useEffect(() => {
        if(value != tmp){
            setValue(tmp);
        }
       // toast.success(value)
     }, [tmp])
     // ----------------------------

    useEffect(() => {
      
        if(String(value).includes(",") || String(value).includes(".")){
            if(!modoFloat){
                setModoFloat(true);
            }
        }
       // toast(value)
       // if(value != tmp){
       //     setTmp(value)
        //}
     
  
     }, [value])

    useEffect(() => {
       if(modoFloat){
        let obbj = document.getElementById(autoIDtemp);
        if(obbj){
            obbj.focus();
            obbj.setSelectionRange(2, obbj.value.length);
        }
       }
    }, [modoFloat])


    const currencyMask = createNumberMask({
        prefix: '',
        decimalSymbol: ',', 
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: '.',
        allowDecimal: true,
        decimalLimit: 3,
        integerLimit: 13,
        allowNegative: false,
        allowLeadingZeroes: false,
    });

    function createClass(mdl){
        let base = "";
        let classe = "";
        //---------------------------------------
        if(mdl == 1){ classe = "bedit-model-1"; }
        else if(mdl == 2){ classe = "bedit-model-2"; }
        else{ classe = "bedit-model-3"; }    
        //---------------------------------------
        return(classe + " " +base)
    }

    return(
        <BMolder modelo={modelo} className={className} width={width} minWidth={minWidth} cor={cor} bordaCor={bordaCor} bordaSize={1}
                 titulo={titulo} disabled={disabled} height={height ? height : null}>
   
                
                { modoFloat ? 
                    <MaskedInput id={autoIDtemp} name={ name ? name : null }
                        className={createClass(modelo ? modelo : 1) + (pulse ? " bmolder-input": "")}
                        style={{ backgroundColor: cor ? cor : null, textAlign:"center"}}
                        mask={currencyMask} 
                        value={ floatToReal(parseFloat(tmp), 3) }
                        disabled={disabled}
                        onChange={(e) => {
                            setTmp(realToFloat(e.target.value, 0, 3));
                           // toast.warn(e)            
                                if(String(e.target.value) == "0"){
                                    delay(()=>{
                                        let obbj = document.getElementById(autoIDtemp);
                                        if(obbj){
                                            obbj.focus();
                                            obbj.select()
                                        }
                                    },250)     
                                } 
                        }} 
                        onFocus={(e) => e.target.select() }
                        inputMode='numeric'    
                    /> 
                :             
                    <div className={"number-input-interno"}  >    
                       {comBtn == true && !disabled && <>     
                    
                        <button onClick={ () => { 
                                    if( safeInt(tmp, min)-1 >= min ){ 
                                        setTmp(safeInt(tmp,min)-1) 
                                    }                                
                              
                                
                            }} >{"-"}</button>
                           
                        </>} 
                      
                        { !carregando && 
                        <input type="number" id={autoIDtemp} name={name ? name : null }
                            className={createClass(modelo ? modelo : 1) + " quantity " + (pulse ? "bmolder-input": "")}
                            min={min} max={max} defaultValue={def ? def : null}  
                            ref={reef} 
                            placeholder={hint ? hint : null}
                            style={{ backgroundColor: cor ? cor : null, textAlign:"center", fontSize: fontSize ? fontSize : null}}
                            disabled={disabled}
                            onKeyUp={ (e) => { 
                                if(String(tmp) == "" || String(tmp) == "0" || String(tmp) == " "){
                                    delay(()=>{
                                        let obbj = document.getElementById(autoIDtemp);
                                        if(obbj){
                                            obbj.focus();
                                            obbj.select();
                                        }
                                    },250)     
                                } 
                                onKeyUp(e); 
                                
                            }}
                            onFocus={(e) =>  (e.target.select(), onEnter ? onEnter() : null)  }
                            onBlur={ onExit ? () => { onExit() } : null  }
                            onKeyDown={ (e) => { if(e.key == ","){  setModoFloat(true); setTmp(e.target.value+",") } handleEnter(e, next)} } 
                            onChange={ (e) => {                        
                                if(String(e.target.value).length <= 0 || safeInt(e.target.value) < min){
                                    setTmp(min);
                                    let obbj = document.getElementById(autoIDtemp);
                                        if(obbj){
                                            delay(()=>{
                                                obbj.focus();
                                                obbj.select();
                                            },250)
                                            
                                        }
                                }else{
                                    setTmp(e.target.value)
                                }  
                            }} 
                            value={ ( String(tmp).includes(",") || String(tmp).includes(".") ) ? tmp : String(tmp).length > 0 ? safeInt(tmp, min) : min }
                        />
                    }
                       
                          {comBtn == true && !disabled && <>   
                            <button onClick={ () => {if(safeInt(tmp,min)+1 <= max){                           
                                    setTmp(safeInt(tmp,min)+1); setCarregando(true); delay(()=>{setCarregando(false)})  } }} >{"+"}</button>     
                            { btnPlus && btnPlus > 0 && <div style={{marginLeft:"5px", minHeight:"19px", minWidth:"19px"}}>
                                <button style={{backgroundColor:"white", minHeight:"19px", minWidth:"19px"}} onClick={ () => {if(safeInt(tmp,min)+parseInt(btnPlus) <= max){                           
                                    setTmp(safeInt(tmp,min)+parseInt(btnPlus)) } }} ><p style={{fontSize:"10px"}}>{String(btnPlus)}</p></button> 
                            </div>}    
                        </>}
                     
                    </div>   
                }
       </BMolder>
    )
}


export const BMolder = ({id, children, icon, modelo=1, className, width, minWidth, maxWidth, cor, titulo, bordaCor, bordaSize=2, semFoco,
                         multiline, disabled, marginTop, marginBottom,marginLeft, height="37px", minHeight, style={}, styleInterno={}, pulse=false }) => {
    function createFundoClass(mdl){
        let base = "";
        let classe = "";
        //---------------------------------------
        if(mdl == 1){ classe = "bedit-fundo-model-1"; }
        else if(mdl == 2){ classe = "bedit-fundo-model-2"; } // all bordas, com pequena margem
        else if(mdl == 3){ classe = "bedit-fundo-model-3"; }
        else{ classe = "bedit-fundo-model-4"; }    
        //---------------------------------------
        return(classe + " " +base)
    }

    let tmp_height = height;

    if(!height && height == null){
        tmp_height = "37px";
    }

    function ghExtr(emu){
        return(emu ? " + 5px " : " + 0px ")
    }

    let isHor = false;
    if(modelo == 4){
        isHor = true;
    }

    const he = isHor ? ("calc("+  tmp_height +ghExtr(multiline) +")") : 
    ( titulo && String(titulo).length > 0 ? "calc("+  tmp_height + ghExtr(multiline) +" + 18px)" : "calc("+  tmp_height +ghExtr(multiline) +")" );

    

    return(<>
        <div  id={id ? id : null} className={"bmolder " + createFundoClass(modelo)+ (pulse ? " bm-force-pulse " : " ")+ (className ? " "+className : " ")} tabIndex={semFoco ? "-1" : null}
                 style={{...style, width: width && width, minWidth: minWidth && minWidth, maxWidth: maxWidth && maxWidth, 
                    height: he,  minHeight: minHeight && minHeight, border: bordaCor ? String(bordaSize)+"px solid "+String(bordaCor) : null,
                    marginTop: marginTop ? marginTop : null, marginBottom: marginBottom ? marginBottom : null, marginLeft: marginLeft ? marginLeft : null,
                 backgroundColor: disabled ? ('rgb(242, 242, 242)') : (cor ? cor : 'white') }}> 
                 {icon ? <>{/* rgb(242, 242, 242)   rgb(248,248,248)*/}
                <div style={{display:"flex", flexDirection:"row", height:"100%", width:"100%", paddingRight:"8px"}}>
                    <div style={{display:"flex", flexDirection:"row", height:"auto", alignItems:"center", justifyContent:"center", paddingLeft:"8px", paddingRight:"8px"}}>
                        {icon}
                    </div>
                    <div style={{display:"flex", flexDirection:"column", width:"100%", height:"100%", justifyContent:"center", marginBottom:"0px"}}>
                        { titulo && String(titulo).length > 0 && <div className="bedit-item-title">{titulo}</div>}
                        <div  style={{height:"auto",width:"100%", backgroundColor:cor ? cor : 'white', overflow:"hidden"}}>          
                            {children}
                        </div>
                    </div>
                </div>
                 </>:
                 <>
             
                    { titulo && String(titulo).length > 0 && <div className="bedit-item-title" 
                            style={{marginTop: modelo == 4 ? "2px" : null, marginLeft: modelo == 4 ? "2px" : null}} >{titulo}</div>}
                    <div  style={{...styleInterno, height:"100%",width:"100%", display:"flex", backgroundColor:cor ? cor : 'white', overflow:"hidden"}}>          
                        {children}
                    </div>
         
                 </>}
             
        </div>
    </>)
}



export const BPassw =({id,name,next,titulo,modelo,reef,className,height,minHeight,width,maxWidth,minWidth,cor,is,limite,value="",setValue,disabled,
    tipo_numero,tipo_alfa,tipo_valor,tipo_pass,tipo_doc,multiline,mask, upper, pulse=true, autoComplete,
    btnExtraClick, btnExtraHint="",btnExtraIcon=<AiFillSetting size={17}/>,
    buscar,bold,hint,onEnter,onKeyEnter,onKeyUp,onExit,align,btn_busca_tx,btn_busca_auto}) => {
        const { isMobile } = useContext(AppContext);
    const [password, setPassword] = useState(value);
    const [passwordCrip, setPasswordCrip] = useState("");

    useEffect(() => {
        setPassword(value);
    }, [value])

    useEffect(() => {
      if(value != String(password)){
        setValue(String(password));      
      }    
      setPasswordCrip(convTxPs(password));
     }, [password])

    function inserirString(string, inserir, posicao) {
       // toast.warn(posicao)
        return string.substring(0, posicao) + inserir + string.substring(posicao);
      }

      function convTxPs(p=""){
        let t = "";
        if(p.length > 0){
            for (let i = 0; i < p.length; i++) {
                t += "#"
            }
        }
        return t;
      }

    function keyup(e){
        if(e.ctrlKey == false ){
            let p = password;
            let pos = e.target.selectionStart;
            let kperm = ['W','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','X','Z','Ç','Y','!','@','#','$','%','&','¨','*','(',')',
                        '{','}','[',']','_','-','-','+',':',';','.',',','¬','§','?','|','^','~','=','0','1','2','3','4','5','6','7','8','9','ª','º','¢']
            //toast.success(String(pos)+'|'+e.key);
            if(kperm.includes(String(e.key).toUpperCase())){
                p = inserirString(p, String(e.key), pos)
            // p += String(e.key);
                setPassword(p)
                
            }else{
                if(String(e.key) == "Backspace"){
                // toast.error(e.key);
                    if(p.length > 0){
                        p = p.substring(0, p.length - 1);
                        setPassword(p);

                    }
                
                }
            }
    
        }
    };

    function createClass(mdl){
        let base = "";
        let classe = "";
        //---------------------------------------
        if(mdl == 1){ classe = "bedit-model-1"; }
        else if(mdl == 2){ classe = "bedit-model-2"; }
        else{ classe = "bedit-model-3"; }    
        //---------------------------------------
        return(classe + " " +base)
    }
    
    return (
        <BMolder id={id ? id : null} modelo={modelo ? modelo : 1} className={className} 
        height={height ? height : null} minHeight={minHeight ? minHeight : null} maxWidth={maxWidth} 
        width={width} minWidth={minWidth} cor={cor} titulo={ 
           titulo && <>
               <div style={{display:"flex", justifyContent:"space-between", overflow:"hidden", alignItems:"center"}}>
                   <p>{titulo}</p>
                   { is ? ((is == "OK" || is == "ALERTA") ? "" : <p style={{color:"red"}}>{String(is)}</p>) : null}
                   { limite > 0 && <>
                   <div className='bcombo-btn-extra'  
                       style={{marginTop:"2px", marginRight:"5px", cursor:"default"}} >     
                       { parseInt(retornaApenasNumeros(width)) >= 100 && <>                
                           <p>{String(value).length}/{limite}</p>   
                       </>}               
                   </div></>}
                   { btnExtraClick && <>
                   <div className='bcombo-btn-extra'  
                           style={{marginTop:"2px", marginRight:"5px"}} >
                       <Tooltip title={btnExtraHint} >
                          
                           <div onClick={()=> {btnExtraClick();}}>
                           {btnExtraIcon}
                           </div>
                           
                           
                       </Tooltip>
                   </div></>}
               </div>
           </>
       } 
        disabled={disabled}
        bordaCor={is ? (is == "OK" ? "rgb(4, 228, 0)" : is == "ALERTA" ? "rgb(253, 255, 15)" : "red") : null}
   
       >
        {isMobile ? <>
           
           <input name={name ? name : null} 
                  className={createClass(modelo ? modelo : 1)+(pulse ? " bmolder-input ": "")}
            type='password'
            value={password}
            autoComplete="off"

            readOnly
            onClick={(e) => e.target.removeAttribute('readOnly')}
            onFocus={(e) => e.target.removeAttribute('readOnly')}
            onBlur={(e) => e.target.setAttribute('readOnly', true)}

            onChange={ (e) => { setPassword(e.target.value) }}
            onKeyUp={ onKeyEnter ? 
                        (e) => (e.key == "Enter" || e.key == "Next" || e.key == "Go" || e.key == "Okay" || e.key == "Ok") && ( onKeyEnter(e) ) 
                        :   
                        null 
                    }    
            style={{ height:"32px", minHeight:"32px", maxHeight:"32px", backgroundColor: cor ? cor : null, textAlign: align ? align : null, 
                fontWeight: bold ? 700 : null,  textTransform: (upper || tipo_alfa) ? "uppercase" : null }}
            disabled={disabled}
                
          /><MdPhoneIphone size={24} style={{marginRight:"8px"}} />
        </> : <>      
          <input name={name ? name : null} className={createClass(modelo ? modelo : 1)+(pulse ? " bmolder-input ": "")}
            
            value={passwordCrip}
            onKeyDown={ e => keyup(e) }

            maxlength={limite && limite > 0 ? String(limite) : null }
            onKeyUp={ onKeyEnter ? 
                        (e) => (e.key == "Enter" || e.key == "Next" || e.key == "Go" || e.key == "Okay" || e.key == "Ok") && ( onKeyEnter(e) ) 
                        :   
                        null 
                    }    
            style={{ backgroundColor: cor ? cor : null, textAlign: align ? align : null, 
                fontWeight: bold ? 700 : null,  textTransform: (upper || tipo_alfa) ? "uppercase" : null }}
            disabled={disabled}
                
          />
          </>}
      </BMolder>
    );
  };

export const BEdit = ({id,name,next, nextKeyDown,titulo,modelo,reef,className,height,minHeight,width,maxWidth,minWidth,cor,is,limite,value,setValue,disabled,
                       tipo_numero,tipo_alfa,tipo_valor,tipo_pass,tipo_doc,multiline,mask, upper, pulse=true, autoComplete, semTeclado=false, help="", 
                       btnExtraClick, btnExtraHint="", autoQuebra, btnExtraIcon=<AiFillSetting size={17}/>, placeHolderColor=false, delayChange, detectaKeyEnter=true,
                       buscar,bold, fontCor="black", fontSize,hint,onEnter,onKeyEnter,onKeyUp,onExit,align,btn_busca_tx,btn_busca_auto}) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);

    
    // -----------------------------
    const [timer, setTimer] = useState(null);
  
    function funcPressDelay(){
        if(delayChange){
            function handleTimeout(){
                delayChange(value)
                //toast.info(value)
            }

            if (timer) { clearTimeout(timer) }      

            if (value) { setTimer(setTimeout(handleTimeout, 500)) }

            return () => clearTimeout(timer);
        }     
    }


    useEffect(() => {
        // funcPressDelay()
    }, [value]);

    
  

    /*
        
    const TimerActionComponent = ({isKeyPressed, setIsKeyPressed, action=()=>{} }) => {
        useEffect(() => {
   
            const handleKey = (event) => {      
                    clearTimeout(timeoutId);
                    if(!timeoutId){            
                            setIsKeyPressed(true);
                            timeoutId = setTimeout(() => {   
                                clearTimeout(timeoutId);
                                setIsKeyPressed(false);
                                action();
                            }, 1000);    
                            
                    }
            };
                
            window.addEventListener('keyup', handleKey);  
            return () => { 
                window.removeEventListener('keyup', handleKey);
            };
        }, []);
  
        return(<></>);
    };
*/

    /// --------------------------



    const [ tmp, setTmp ] = useState(value);
     
    useEffect(() => {
        
        if(value != tmp){
            if(limite && limite >= 1){
                if(autoQuebra && String(value).length > limite){
                    let tx = String(value);
                    setTmp(String(tx).substring(0, limite));
                    autoQuebra( () => String(tx).substring(limite, limite + 219))
                    focusComponent(next, true);
                }else{
                    setTmp(String(value).substring(0, limite));
                }
            }else{
                setTmp(value);
            }
     
        }
       // toast.success(value) autoComplete
     }, [value])

         
    useEffect(() => {
   

        if(value != tmp){
            if(limite && limite >= 1){
                if(autoQuebra && String(tmp).length > limite){
                    let tx = String(tmp);
                    setValue(String(tx).substring(0, limite));
                    autoQuebra( () => String(tx).substring(limite, limite + 219))
                    focusComponent(next, true);
                }else{
                    setValue(String(tmp).substring(0, limite));
                }
            }else{
                setValue(tmp);
            }
      
        }
       // toast.success(value)
     }, [tmp])


    function createClass(mdl){
            let base = "";
            let classe = "";
            //---------------------------------------
            if(mdl == 1){ classe = "bedit bedit-model-1"; }
            else if(mdl == 2){ classe = "bedit bedit-model-2"; }
            else{ classe = "bedit bedit-model-3"; }    
            //---------------------------------------

            if(placeHolderColor){
                classe += " bedit-color-place-holder "
            }

            return(classe + " " +base)
        }

    function alfaNum(e=""){
        let res = safeStr(e).toUpperCase();

            res = res.BReplace("  ","").BReplace(" ","").BReplace('"','').BReplace("'","").BReplace("¨","").BReplace("'","").BReplace("!","");
            res = res.BReplace("@","").BReplace("#","").BReplace("$","").BReplace("%","").BReplace("&","").BReplace("*","").BReplace("(","");
            res = res.BReplace(")","").BReplace("-","").BReplace("_","").BReplace("+","").BReplace("=","").BReplace("§","").BReplace("¬","");
            res = res.BReplace("\\","").BReplace("|","").BReplace("<","").BReplace(">","").BReplace(",","").BReplace(".","").BReplace(":","");
            res = res.BReplace(";","").BReplace("?","").BReplace("ª","").BReplace("º","").BReplace("°","").BReplace("/","").BReplace(" ","");
       
        return res;
    }
        
    return(<>

            <BMolder id={id ? id : null} modelo={modelo ? modelo : 1} className={className} 
                     height={height ? height : null} minHeight={minHeight ? minHeight : null} maxWidth={maxWidth} 
                     width={width} minWidth={minWidth} cor={cor} titulo={ 
                        titulo && <>
                            <div style={{display:"flex", justifyContent:"space-between", overflow:"hidden", alignItems:"center"}}>
                                <p>{titulo}</p>
                                { is ? ((is == "OK" || is == "ALERTA") ? "" : <p style={{color:"red"}}>{String(is)}</p>) : null}
                                { limite > 0 && <>
                                <div className='bcombo-btn-extra'  
                                    style={{marginTop:"2px", marginRight:"5px", cursor:"default"}} >     
                                    { parseInt(retornaApenasNumeros(width)) >= 100 && <>                
                                        <p>{safeStr(value).length}<strong style={{marginLeft:"3px",marginRight:"3px"}}>/</strong>{limite}</p>   
                                    </>}               
                                </div></>}
                                { btnExtraClick && <>
                                <div className='bcombo-btn-extra'  
                                        style={{marginTop:"2px", marginRight:"5px"}} >
                                    <Tooltip title={btnExtraHint} >
                                       
                                        <div onClick={()=> {btnExtraClick();}}>
                                        {btnExtraIcon}
                                        </div>
                                        
                                        
                                    </Tooltip>
                                </div></>}
                                {String(help).length > 0 && <div><Tooltip title={String(help)} 
                                        zIndex={999999}><FaQuestionCircle size={14} color={"rgb(69, 106, 121)"} 
                                        style={{marginLeft:"5px"}}/></Tooltip></div> }  
                            </div>
    
                        </>
                    } 
                     disabled={disabled}
                     bordaCor={is ? (is == "OK" ? "rgb(4, 228, 0)" : is == "ALERTA" ? "rgb(253, 255, 15)" : "red") : null}
                
                    >
                   { multiline == true ?
                    <textarea name={name ? name : null} className={createClass(modelo ? modelo : 1)+(pulse ? " bmolder-input ": "")}
                        type={tipo_numero || tipo_valor ? "number" : "text"} 
                        ref={reef} 
                        style={{ backgroundColor: cor ? cor : null, textAlign: align ? align : null, 
                            fontWeight: bold ? 700 : null, minHeight: minHeight ? minHeight : null,
                            textTransform: (upper || tipo_alfa) ? "uppercase" : null }}
                        disabled={disabled}
                        placeholder={hint && hint}
                        onFocus={(e) =>  (e.target.select(), onEnter ? onEnter() : null)  }
                        maxlength={ limite && limite > 0 ? String(limite) : null }
                        onKeyDown={ buscar && value.length > 0 ? null : (e) => handleEnter(e, next)}
                        onKeyUp={ 
                            buscar ? 
                                (e) => e.key == "Enter" || e.key == "Next" || e.key == "Go" || e.key == "Okay" || e.key == "Ok" || e.key == "Alt" ? 
                                        (buscar(value), handleEnter(e, next) ) 
                                    : 
                                       onKeyUp ? onKeyUp(e.key.toLowerCase()) : null  
                            :   
                                onKeyUp ? (e) => onKeyUp(e.key.toLowerCase()) : null 
                            } 
                    onChange={(e) => setValue && setValue( tipo_valor ? (e.target.value) : e.target.value)} 
                    value={value}/>
                    : mask ? 
                    <MaskedInput name={ name ? name : null }
                    mask={mask} 
                    maxlength={limite && limite > 0 ? String(limite) : null }
                    className={createClass(modelo ? modelo : 1)+(pulse ? " bmolder-input ": "")}
                        type={tipo_numero || tipo_valor ? "number" : tipo_doc ? "tel" : "text"} 
                        ref={reef} 
                        style={{ backgroundColor: cor ? cor : null, textAlign: align ? align : null, color: fontCor ? fontCor : "black", 
                            fontSize: fontSize ? fontSize : null, 
                            fontWeight: bold ? 700 : null,  textTransform: (upper || tipo_alfa) ? "uppercase" : null }}
                        disabled={disabled}
                        placeholder={hint && hint}
                        onFocus={(e) =>  (e.target.select(), onEnter ? onEnter() : null)  }
                        onBlur={ onExit ? () => { onExit() } : null } 
                        onKeyDown={ buscar ? null : (e) => handleEnter(e, next)}
                        onKeyUp={ 
               
                            buscar ?        
                            (e) => e.key == "Enter" || e.key == "Next" || e.key == "Go" || e.key == "Okay" || e.key == "Ok" || e.key == "Alt"? 
                                    (buscar(value), handleEnter(e, next) ) 
                                : 
                                    onKeyUp ? onKeyUp(e.key.toLowerCase()) : null  
                        :   
                            onKeyUp ? (e) => onKeyUp(e.key.toLowerCase()) : null 
                            } 
                    onChange={(e) => setValue && setValue( tipo_valor ? (e.target.value) : e.target.value)} 
                    value={value}

                    //inputMode='numeric'       
                    />               
                    :
                    <input inputmode={semTeclado && 'none'} name={name ? name : null} 
                           className={createClass(modelo ? modelo : 1)+(pulse ? " bmolder-input ": "")}
                        type={tipo_numero || tipo_valor ? "text" : buscar ? "search" : tipo_pass ? "password": "text" } 
  
                        ref={reef} 
                        autoComplete={tipo_pass ? autoComplete: "off" }
                        // maxlength={limite && limite > 0 ? String(limite) : null }
                        style={{              
                            backgroundColor: cor ? cor : null, textAlign: align ? align : null, 
                            color: fontCor ? fontCor : "black",
                            fontSize: fontSize ? fontSize : null,
                            fontWeight: bold ? 700 : null,  
                            textTransform: (upper || tipo_alfa) ? "uppercase" : null,                        
                        }}
                        disabled={disabled}
                        up
                 
                 
                        placeholder={hint && hint}
                        onFocus={(e) =>  (e.target.select(), onEnter ? onEnter() : null)  }
                        onBlur={ onExit ? () => { onExit() } : null } 
                        onKeyDown={ (event) =>{
                           // toast.info(event.key)
                                if(event.key == "ArrowDown" && nextKeyDown){
                                    //toast("FAFAFFA")   
                                    event.preventDefault()                              
                                    focusComponent(nextKeyDown, true);
                                }else{

                            if(buscar && detectaKeyEnter) {
                                 //..
                              } else { 
                                
                                    handleEnter(event, next); 
                                    // toast.success(event.key)
                                    if(tipo_alfa && (event.key == ' ' || event.key == ' ' || event.key == '"' || event.key == "'" 
                                    || event.key == '¨'|| event.key == '&'|| event.key == '%'|| event.key == '$'|| event.key == '!'|| event.key == '*'
                                    || event.key == '_'|| event.key == '-'|| event.key == '='|| event.key == '+'|| event.key == '-'|| event.key == '/'
                                    || event.key == '\\'|| event.key == ','|| event.key == '.'|| event.key == ':'|| event.key == ';'|| event.key == '?'
                                    || event.key == 'ª'|| event.key == 'º'|| event.key == '<'|| event.key == '>'|| event.key == '('|| event.key == ')'
                                    || event.key == '['|| event.key == ']'|| event.key == '{'|| event.key == '}'|| event.key == '|'|| event.key == '.')){
                                        event.preventDefault()
                                    } 
                                    if( tipo_numero && event.key < 0 && event.key > 9){
                                        event.preventDefault()
                                    }
                                
                            }
                            }
                        }}

                        onKeyUp={()=>{  
                            funcPressDelay();
                        }}
                        onKeyPress={ 

                            (buscar && detectaKeyEnter) ?        
                                (e) => e.key == "Enter" || e.key == "Next" || e.key == "Go" || e.key == "Okay" || e.key == "Ok" || e.key == "Alt"? 
                                    (  buscar(value), handleEnter(e, next) ) 
                                    : 
                                    onKeyUp ? onKeyUp(e.key.toLowerCase()) : null  
                            : (onKeyEnter && detectaKeyEnter) ? 
                                (e) => (e.key == "Enter" || e.key == "Next" || e.key == "Go" || e.key == "Okay" || e.key == "Ok" || e.key == "Alt") && 
                                    ( onKeyEnter(e) ) 
                            :   
                            onKeyUp ? (e) => onKeyUp(e.key.toLowerCase()) : null 
                            }    
                            
                    value={ limite && limite >= 1 ? String(tmp).substring(0, limite) : tmp}      

                    onChange={(e) => setValue && ( tipo_numero ? 
                                        setValue( retornaApenasNumeros(String(e.target.value)))
                                        : 
                                        upper ? setValue(sanString(e.target.value.toUpperCase()) ) 
                                                : 
                                                tipo_alfa ? setValue(sanString(alfaNum(e.target.value)) ) 
                                                            : 
                                                            setTmp(sanString(e.target.value)) 
                                    ) } 
                    />


                    

                    }

                    {/*
                    
                     userSelect:"all", MozUserSelect:"all", WebkitUserSelect:"all"
                    */}
                    
                    { btn_busca_auto && <>
                        <Tooltip title={"Busca automática ativada"}>
                        <div style={{marginRight:"0px", marginTop:"0px", padding:"4px", 
                                     width:"auto", height:"100%", display:"flex" ,alignItems:"center"  }}>
                        <div style={{marginRight:"0px", marginTop:"0px", padding:"4px", 
                                     width:"auto", paddingLeft:"7px", paddingRight:"6px",height:"100%", display:"flex" ,
                                     alignItems:"center", justifyContent:"space-around",
                                     backgroundColor:"rgb(231, 231, 231)", borderRadius: "10px"  }}>
                            <p style={{fontSize:"11px", color:"rgb(150, 150, 150)",  }} >{ 
                                     btn_busca_tx ? ( btn_busca_tx == "-" ? "" : btn_busca_tx ) : "auto" } </p>
                            <VscSearch size={14} style={{ minWidth:"14px" }} color={"rgb(150, 150, 150)"} onClick={ (e) => {  
                            if(buscar ) { buscar(value); handleEnter(e, next); }
                            } } />
                        </div></div></Tooltip>
                    </>}
                    { buscar && !btn_busca_auto && <div style={{height:"100%", display:"flex", alignItems:"center", paddingTop:"2px"}}>
                        <VscSearch size={18} style={{marginRight:"8px", cursor:"pointer", minWidth:"18px"}} onClick={ (e) => {  
                        if(buscar ) { buscar(value); handleEnter(e, next); }
                        } } />
                    </div>}
                  
            </BMolder>
    </>)
}

const dateFormat = 'DD/MM/YYYY';


export const BTags = ({children, modoLinha=false, titulo, lista, setLista = ()=> {}, onClickAdicionar, onInsert = (e)=>{return(e)}}) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);
    return(<>
        <BMolder titulo={titulo} height='auto' modelo={2}>
            <div style={{width:"100%"}}>
                <div style={{width:"100%", height:"37px", borderBottom:"1px solid rgb(212, 218, 221)", padding:"5px", display:"flex",
                    alignItems:"center", gap:"5px"
                }}>
                    <div style={{height:"100%", width:"85px", border:"1px solid rgb(199, 199, 199)",
                                 backgroundColor:"rgb(243, 243, 243)", display:"flex", alignItems:"center", justifyContent:"center",
                                 cursor:"pointer"}} onClick={()=>{
                                    if(onClickAdicionar){
                                        onClickAdicionar();
                                    }else{
                                        let cood = prompt('Informe uma observação');
                                        if(safeStr(cood).length > 7){   
                                            cood = onInsert(cood);
                                            if(safeStr(cood).length > 7){  
                                                let tmp = modoLinha ? [...String(lista).split(";")] : lista
                         
                                                if(tmp.includes(cood)){
                                                    toast.warn("Já existe na lista!")
                                                }else{
                                                    if(modoLinha){
                                                        setLista(lista+";"+safeStr(cood))
                                                    }else{
                                                        setLista([...lista, safeStr(cood)])
                                                    }       
                                                }    
                                            }
                                        }      
                                    }
                                    
                                 }}>Adicionar</div>                 
                    {children}
                </div>
                <div style={{width:"100%", height:"auto", }}>
                    {lista && modoLinha == false && lista.map( p => {
                        if(safeStr(p).length > 0){
                            return(<div style={{height:"37px", borderRadius:"9px", border:"1px solid rgb(162, 194, 203)", 
                                        margin:"5px", display:"flex", alignItems:"center", 
                                justifyContent:"space-between", backgroundColor:"rgb(229, 242, 242)", paddingLeft:"10px", paddingRight:"10px"}}>
                                <p>{String(p)}</p>
                                <strong style={{cursor:"pointer"}} title='Remover' onClick={()=>{
                                    setLista(lista.filter(t => t != p))
                                }}>X</strong>
                            </div>)
                        }
                    })}
                    {lista && modoLinha && String(lista).split(";").map( p => {
                        if(safeStr(p).length > 0){
                            return(<div style={{height:"37px", borderRadius:"9px", border:"1px solid rgb(162, 194, 203)", 
                                        margin:"5px", display:"flex", alignItems:"center", 
                                justifyContent:"space-between", backgroundColor:"rgb(229, 242, 242)", paddingLeft:"10px", paddingRight:"10px"}}>
                                <p>{String(p)}</p>
                                <strong style={{cursor:"pointer"}} title='Remover' onClick={()=>{
                                    let tmp = lista.split(";").filter(t => t != p)
                                    let tx = "";
                                    tmp.map(t => { if(String(t).length > 0){
                                        if(tx.length > 0){
                                            tx = tx + ";" + String(t)
                                        }else{
                                            tx = String(t)
                                        }             
                                    }})
                                    setLista(String(tx))
                                
                                }}>X</strong>
                            </div>)
                        }
                    })}
                </div>      
            </div>
        </BMolder>
    </>)
}




export const BSpin = ({children, display=false, carregando=true, texto="Carregando...", sub="", txBtn, corBtn, onClick}) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);
    return(<>
            {display ? <>
                <div className={'bspin-content'} >
                { children }
                <div className={'bspin-box'} >           
                    <div className={'bspin-center'} >
                        { carregando && <>
                            <LoadingOutlined style={{ fontSize: 38}} spin />
                            <p className="bspin-texto">{texto}</p> 
                            <p>{sub}</p> 
                        </> }
                     
                        
                    </div>           
                </div>
                </div>
            </>:<>
            { children }</>}         
        </>
    )
}


export const BSpinIntern = ({children, item_pai, display=false, carregando=true, texto="Carregando...", sub="",opacidade, txBtn, corBtn, onClick}) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);
    //const  ta = {offsetTop: "10px", offsetLeft: "10px", offsetLeft: "10px", offsetHeight: "10px"}
    const [ ta, setTa ] = useState({offsetTop: "10px", offsetLeft: "10px", offsetLeft: "10px", offsetHeight: "10px"});

    useEffect(()=> {   
        if(item_pai){
            try{
                if(document.getElementById(item_pai) != null){
                    setTa(document.getElementById(item_pai));
                }else{
                    delay(()=> {                    
                        if(document.getElementById(item_pai) != null){
                            setTa(document.getElementById(item_pai));
                            }
                    }, 1500);
                }
                //  delay(()=> { ta = document.getElementById(item_pai);  }, 1000);
            
            }catch{
               // alert(item_pai)
            }
        }

    },[]);
  

    return(<>
            {display ? <>
                
                <div className={'bspin-intern-box'} style={{top:ta.offsetTop, left:ta.offsetLeft, height: ta.offsetHeight, minHeight: ta.offsetHeight, 
                                                            width: ta.offsetWidth, minWidth:ta.offsetWidth, opacity:opacidade ? opacidade : null}} >           
                    <div className={'bspin-intern-center'} style={{height: ta.offsetHeight, minHeight: ta.offsetHeight}}>
                        { carregando && <>
                            <LoadingOutlined style={{ fontSize: parseInt(ta.offsetHeight) <= 80 ? 20 : 38}} spin />
                        </> }
                        { texto.length > 0 && <>
                            <p className="bspin-intern-texto" style={{ fontSize:  parseInt(ta.offsetHeight) <= 80 ? 14 : 20 }}>{texto}</p> 
                            <p>{sub}</p> 
                        </> }
                        
                     
                     
                        
                    </div>           
                </div>
                { children }
            </>:<>
            { children }</>}         
        </>
    )
}

export const BSpinDiv = ({className, style, id, children, display=false, carregando=true,focavel=false, texto="Carregando...", sub,opacidade, onBlur,onKeyUp,
    txBtn, corBtn="black", onClickFundo, onClick}) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);
    //const  ta = {offsetTop: "10px", offsetLeft: "10px", offsetLeft: "10px", offsetHeight: "10px"}
   
    return(<>
        <div className={ (className ? (className+ " ") : "") + "bspin-div-div"} tabindex= {focavel ? "0" : null} 
        onBlur={ onBlur && onBlur}
        onKeyUp={ onKeyUp && onKeyUp }
        style={style} id={id} autocomplete={"off"} onClick={onClickFundo}>
            {display ? <>
                
                <div className={'bspin-div-box'} style={{opacity:opacidade ? opacidade : null}} >           
                    <div className={'bspin-div-center'}>
                        <div className={'bspin-div-tx'}>
                            { carregando && <>
                            
                            
                            
                            
                       
                                
                              {/*
                                <Icon arq={icon_load} size={"60px"} marginLeft={"0px"} marginRight={"0px"} modoGif={true} />
                               */}  
                           
                              { <div style={{height:"40px", width:"40px"}}>
                                    <LoadingOutlined style={{ fontSize: 24, color:"black", marginRight:"8px"}}  spin />
                                </div>
                                // 
                              }  
                            </> }
                            { texto.length > 0 && <><div className={'bspin-div-info'}>
                                <p className="bspin-div-texto" style={{ fontSize: 14 }}>{texto}</p> 
                                { sub && <><div>{sub}</div>  </> }
                                </div> 
                            </> }
                        </div>

                        <div>
                            {txBtn && onClick && <BButton cor={corBtn} texto={txBtn} onClick={()=>{onClick()}}/>}      
                        </div>    
                     
                        
                    </div>    
                    
                </div>
                { children }
            </>:<>
            { children }</>}      
        </div>   
        </>
    )
}

export const BDate = ({modelo, tipo, className, value="", setValue = ()=> {},
                       width, minWidth, cor, titulo, disabled, debug=false }) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);
    const [ d_formatBR, setD_formatBR ] = useState('DD/MM/YYYY');
    const d_format = 'YYYY-MM-DD';

    const [interno_data, setInterno_Data] = useState('');

    useEffect(() => {
        if(tipo)
        {
            if(tipo == 'date'){ // 
                setD_formatBR('DD/MM/YYYY');
              }else if(tipo == 'month'){ // 
                setD_formatBR('MM/YYYY');
              }else if(tipo == 'year'){ //
                setD_formatBR('YYYY');
              }else{ // 
                setD_formatBR('DD/MM/YYYY');
              }
        }

      }, []);

    function createClass(mdl){
            let base = "";
            let classe = "";
            //---------------------------------------
            if(mdl == 1){ classe = "bedit-model-1"; }
            else if(mdl == 2){ classe = "bedit-model-2"; }
            else{ classe = "bedit-model-3"; }    
            //---------------------------------------
            return(classe + " " +base)
        }

      
    
        useEffect(() => {
   
            //let ttt = "2020-05-02"
            //let ttt = "01/05/2020"
            let isBR = false;
            if(String(value).includes('/')){ isBR = true }

            

            if(String(dayjs(interno_data, d_formatBR).format(d_format)) != String(value)){
            
                if(String(value).length > 4 && String(value) != "invalid date"){
                    let tmp = ""
                    if(isBR){
                        tmp = (dayjs(String(value).toLocaleString(), d_formatBR))
                    }else{
                        tmp = (dayjs(String(value).toLocaleString(), d_format))
                    }  
                    setInterno_Data(tmp);
                    if(String(value) != String(tmp.format(d_format))){
                        setValue(String(tmp.format(d_format)));
                    }               
                }else{           
   
                    let tmp = dayjs(new Date());
                    setInterno_Data(tmp);
                    setValue(String(tmp.format(d_format)) );
                }
            }
        }, [value]);  

    return(<>    
       { debug && <>
        <p>Data :: {String(value)}</p>
        <p>Interno :: {String(interno_data)}</p>   
        </>}
        <BMolder modelo={modelo ? modelo : 1} className={className} width={width ? width : "250px"} 
                 minWidth={minWidth ? minWidth : null} cor={cor} titulo={titulo} disabled={disabled}>
  
        
        <DatePicker className={createClass(modelo ? modelo : 1)} size="small" picker={tipo ? tipo : "date"}
                    value={interno_data} disabled={disabled} onFocus={(e) => e.target.select() }
                    format={d_formatBR} style={{width: "100%" }} width={"100%"} 
                    onChange={(e) => { 
                        setInterno_Data(e); 
                        setValue(String(dayjs(e, d_formatBR).format(d_format)) );
                    }} 
        />
 
            {/* 
                onChange={(date, dateString) => {props.setValue(String(safeStr(dateString).split("T",1)).replace("[").replace("'").replace("]").replace("'"));} }
                value={ props.value === moment ? props.value.format(dformat) : moment(props.value, dformat) }
                
                />    
            */}
        </BMolder></>
    )
}

export const BDate2 = ({modelo, tipo, className, value="", setValue = ()=> {},
                       width, minWidth, cor, titulo, disabled, debug=false }) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);
    const [ d_formatBR, setD_formatBR ] = useState('DD/MM/YYYY');
    const d_format = 'YYYY-MM-DD';

    const [interno_data, setInterno_Data] = useState('');

    useEffect(() => {
        if(tipo)
        {
            if(tipo == 'date'){ // 
                setD_formatBR('DD/MM/YYYY');
              }else if(tipo == 'month'){ // 
                setD_formatBR('MM/YYYY');
              }else if(tipo == 'year'){ //
                setD_formatBR('YYYY');
              }else{ // 
                setD_formatBR('DD/MM/YYYY');
              }
        }

      }, []);

    function createClass(mdl){
            let base = "";
            let classe = "";
            //---------------------------------------
            if(mdl == 1){ classe = "bedit-model-1"; }
            else if(mdl == 2){ classe = "bedit-model-2"; }
            else{ classe = "bedit-model-3"; }    
            //---------------------------------------
            return(classe + " " +base)
        }

      
    
        useEffect(() => {

            //let ttt = "2020-05-02"
            //let ttt = "01/05/2020"
            let isBR = false;
            if(String(value).includes('/')){ isBR = true }

           // if(isBR){
               // alert(moment(String(value).toLocaleString(), d_formatBR))
            //}else{
               // alert(moment(String(value).toLocaleString(), d_format))
           //}
            
           // alert(moment(String(value).toLocaleString(), d_format))
         
            if(String(dayjs(interno_data, d_formatBR).format(d_format)) != String(value)){
            
                if(String(value).length > 4 && String(value) != "invalid date"){
                    let tmp = ""
                    if(isBR){
                        tmp = (dayjs(String(value).toLocaleString(), d_formatBR))
                    }else{
                        tmp = (dayjs(String(value).toLocaleString(), d_format))
                    }  
                    setInterno_Data(tmp);
                    if(String(value) != String(tmp.format(d_format))){
                        setValue(String(tmp.format(d_format)));
                    }               
                }else{           

                    let tmp = dayjs(new Date());
                    setInterno_Data(tmp);
                    setValue(String(tmp.format(d_format)) );
                }
            }
        }, [value]);  

    return(<>    
       { debug && <>
        <p>Data :: {String(value)}</p>
        <p>Interno :: {String(interno_data)}</p>   
        </>}
        <BMolder modelo={modelo ? modelo : 1} className={className} width={width ? width : "250px"} 
                 minWidth={minWidth ? minWidth : null} cor={cor} titulo={titulo} disabled={disabled}>
  
         {/*
        <MyDatePicker selected={interno_data} onChange={(e) => { 
                        setInterno_Data(e); 
                        setValue(String(dayjs(e, d_formatBR).format(d_format)) );
                    }} />
       */}
        <DatePicker className={createClass(modelo ? modelo : 1)} 
                    size='small'
                    value={interno_data} disabled={disabled} onFocus={(e) => e.target.select() }
                    format={d_formatBR} style={{width: "100%" }} width={"100%"} 
                    inputReadOnly={true}
                    onChange={(e) => { 
                 
                        setInterno_Data(e); 
                        setValue(String(dayjs(e, d_formatBR).format(d_format)) );
                    }} 
        />
 
            {/* 
                onChange={(date, dateString) => {props.setValue(String(safeStr(dateString).split("T",1)).replace("[").replace("'").replace("]").replace("'"));} }
                value={ props.value === moment ? props.value.format(dformat) : moment(props.value, dformat) }
                
                />    
            */}
        </BMolder></>
    )
}


export const BDateRange = ({data_a="", data_b="", titulo,modelo=1,disabled=false, setData_a = ()=> {}, setData_b = ()=> {}, a_dias=0, b_dias=0, width }) => {

    const d_formatBR = 'DD/MM/YYYY';
    const d_format = 'YYYY-MM-DD';
    const { RangePicker } = DatePicker;

    const [interno_data_a, setInterno_Data_a] = useState('');
    const [interno_data_b, setInterno_Data_b] = useState('');

    

    useEffect(() => {
        let isBR = false;
        if(String(data_a).includes('/')){ isBR = true }

        if(String(dayjs(interno_data_a, d_formatBR).format(d_format)) != String(data_a)){
            if(String(data_a).length > 4 && String(data_a) != "invalid date"){
                    let tmp = ""
                    if(isBR){
                        tmp = (dayjs(String(data_a).toLocaleString(), d_formatBR))
                    }else{
                        tmp = (dayjs(String(data_a).toLocaleString(), d_format))
                    }  
                    setInterno_Data_a(tmp);
                    if(String(data_a) != String(tmp.format(d_format))){
                        setData_a(String(tmp.format(d_format)));
                    }               
            }else{    
                let tmp = dayjs(new Date());
                if(a_dias < 0){
                    tmp = tmp.subtract((a_dias *= -1), 'days')
                }
                setInterno_Data_a(tmp);
                setData_a(String(tmp.format(d_format)) );
              
                /*             
      
                if(a_dias > 0){
                    tmp.add(a_dias-1, 'days')
                }
                if(a_dias < 0){
                    tmp.subtract((a_dias *= -1), 'days')
                }
                setInterno_Data_a(tmp);  
    
               */
            }
        }
     
    }, [data_a]);  
    
    useEffect(() => {
        let isBR = false;
        if(String(data_b).includes('/')){ isBR = true }

         if(String(dayjs(interno_data_b, d_formatBR).format(d_format)) != String(data_b)){
             if(String(data_b).length > 4 && String(data_b) != "invalid date"){
                let tmp = ""
                if(isBR){
                    tmp = (dayjs(String(data_a).toLocaleString(), d_formatBR))
                }else{
                    tmp = (dayjs(String(data_a).toLocaleString(), d_format))
                }  
                setInterno_Data_b(tmp);
                if(String(data_a) != String(tmp.format(d_format))){
                    setData_b(String(tmp.format(d_format)));
                }               
             }else{           
                let tmp = dayjs(new Date());
                setInterno_Data_b(tmp);
                setData_b(String(tmp.format(d_format)) );          
                /*
                if(b_dias > 0){
                    tmp.add(b_dias-1, 'days')
                }
                if(b_dias < 0){
                    tmp.subtract( (b_dias *= -1) -1, 'days')
                }
                */
             }
         }
     }, [data_b]); 
                           
    return(<>
        {/*
        <p>Data A :: {String(data_a)}</p>
        <p>Data B :: {String(data_b)}</p>
        <p>Interno A :: {String(interno_data_a)}</p>
        <p>Interno B :: {String(interno_data_b)}</p>
        */}
        <BMolder modelo={modelo ? modelo : 1} width={width ? width : "230px"} 
                 titulo={titulo} disabled={disabled}>
  
            <RangePicker  value={[interno_data_a, interno_data_b]} bordered={false}
                        format={d_formatBR} style={{width: width ? width : "230px"}} 
                        inputReadOnly={true}
                        onChange={(e) => { 
                            setInterno_Data_a(e[0]); 
                            setInterno_Data_b(e[1]);   
                            setData_a(String(dayjs(e[0], d_formatBR).format(d_format)) );
                            setData_b(String(dayjs(e[1], d_formatBR).format(d_format)) ); 
                        }} 
            />
        </BMolder>
    </>)
}


const MonetaryInput = ({ value, onChange, className, name, style, disabled,onExit,onKeyDown,onKeyUp,onBlur,onFocus }) => {
    const [amount, setAmount] = useState( value && safeStr(value).length > 0 && value > 0 ? floatToReal(value) : "");

    useEffect(() => {  
        //toast.info(value)
        let ttp = floatToReal(value);
        let ttp2 = amount;
        if(ttp2 == "" || ttp2 == "0"){
            ttp2 = "0,00"
        }
        if(value > 0){
            if(ttp != ttp2){  
          
               setAmount(floatToReal(value))    
            }            
        }
        else{
            setAmount("")    
        }

      }, [value]);
  
    const handleInputChange = (event) => {
      const inputValue = (event.target.value);
  
      // Remove caracteres não numéricos
      const numericValue = inputValue.replace(/[^0-9]/g, '');
  
      // Obtém o valor dos centavos
      let cents = numericValue.slice(-2);
        if(cents.length == 1){
            cents = "0"+cents;
        }
  
      // Obtém o valor dos reais
      let reais = numericValue.slice(0, -2);
      if(reais.length >= 2 && reais[0] == "0"){
        reais = reais.substring(1);
      }

      // Formata o valor com separador de milhares
      const formattedValue = reais.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
      // Atualiza o estado do campo de input
      let tmp = formattedValue + ',' + cents;
 
      setAmount(tmp);

        onChange(realToFloat(tmp));
    };

    return (
      <input
        className={className}
        name={name}
        type="text"
        value={amount}
        onChange={handleInputChange}
        placeholder="0,00"
        inputMode='numeric'
        rightToLeft={true}

        style={style}
        disabled={disabled} 
    
        onKeyDown={ e => onKeyDown ? onKeyDown(e) : null}
        onKeyUp={ e => onKeyUp ? onKeyUp(e) : null}
        onBlur={ e => onBlur ? onBlur(e) : null} 
        onFocus={ e => onFocus ? onFocus(e) : null}
        
      />
    );
  };
  
  export default MonetaryInput;

export const BValor = ({titulo="", className, minWidth, name, id, next, value, setValue, fontSize, cor,corFonte, modelo=1, bordaCor, disabled=false, width, txPos="end",
                        height, autoP=-1, porcento, onExit, onEnter, onKeyUp = ()=>{}, pulse=true}) => {
    /* Obs
       Entrada de valor (VALUE) é FLOAT, e a saída (setValue) por padrão tbm é FLOAT.
    */

       const idd = (id && String(id).length > 0) ? id : "BValor"+randomNumStr(999)+randomNumStr(99)+randomNumStr(9)+String(titulo.length)+randomNumStr(99)

        function createClass(mdl){
            let base = "";
            let classe = "";
            //---------------------------------------
            if(mdl == 1){ classe = "bedit-model-1"; }
            else if(mdl == 2){ classe = "bedit-model-2"; }
            else{ classe = "bedit-model-3"; }    
            //---------------------------------------
            return(classe + " " +base)
        }

        const currencyMask2 = createNumberMask({
            prefix: '',
            decimalSymbol: ',', 
            includeThousandsSeparator: false,
            thousandsSeparatorSymbol: '.',
            allowDecimal: true,
            decimalLimit: 3,
            integerLimit: 3,
            allowNegative: false,
            allowLeadingZeroes: false,
            default: 0,
        });


       function pressP(e){
        if(autoP >= 0 && e.keyCode === 32){ // espaço = 32

            setValue(autoP);
        }
       }

    useEffect(() => {
        if(isFocusedComponentPorID(idd)){
            if(String(value) == "0" || String(value) == "0,00" || 
                String(value) == "0,000" || String(value) == "0.00"|| String(value) == "0.000"){       
                selectComponentPorID(idd)
            }
        }
    }, [value]);


    return(
        <BMolder modelo={modelo} className={className} width={width} minWidth={minWidth} cor={cor} bordaCor={bordaCor} bordaSize={1}
                 titulo={titulo} disabled={disabled} height={height ? height : null}>
                    { !porcento && <>
                <MonetaryInput 
                    className={createClass(modelo ? modelo : 1)+(pulse ? " bmolder-input ": "")}
                    value={ value }
                    onChange={ (e) => { setValue(e) } } 
                    name={name ? name : null }
                    id={idd}
                    style={{ backgroundColor: cor ? cor : null, textAlign:txPos, fontSize: fontSize ? fontSize : null, color: corFonte ? corFonte : null}}
                    disabled={disabled}
                    onExit={onExit}
                    onKeyDown={ (e) => { pressP(e); handleEnter(e, next)}}
                    onKeyUp={ (e) => { onKeyUp(e) }}
                    onBlur={ onExit ? () => { onExit() } : null } 
                    onFocus={(e) => (e.target.select(), onEnter ?  onEnter() : null) }

                />
                </>}
                { porcento && <>
                    <MaskedInput name={ name ? name : null }
                    rightToLeft={true}
                    className={createClass(modelo ? modelo : 1) + (pulse ? " bmolder-input ": "")}
                    style={{ backgroundColor: cor ? cor : null, textAlign:txPos, fontSize: fontSize ? fontSize : null, color: corFonte ? corFonte : null}}
                    mask={ currencyMask2 } 
                    id={idd}
                    value={floatToReal(value, 3, "","", true) }
                    disabled={disabled} 
                    onKeyDown={ (e) => { pressP(e); handleEnter(e, next)}}
                    onKeyUp={ (e) => { onKeyUp(e)
                    }}
                    onBlur={ onExit ? () => { onExit() } : null } 
                    onChange={(e) => {
                        //toast.success(floatToReal(realToFloat("5.008", 0, 3), 3, "","", true))
                            setValue(realToFloat(e.target.value, 0, 3) ); 
                     
                       
                     }} 
                    onFocus={(e) => (e.target.select(), onEnter ?  onEnter() : null) }
                    inputMode='numeric'
                      
                /> 
                <div style={{height:"100%", display:"flex", alignItems:"center"}}>
                    <p style={{fontSize:"16px", marginRight:"4px", fontFamily:"sans-serif"}}>%</p>
                </div>
                </>}
             
            </BMolder>

    )

}

export const BCombo = ({children, hor_small, titulo, full, small, lado, setValue, value, reef, next, style="", setKey, setAux, width, height="46px"}) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);

 
    const getClassItem = () => { 
            if(full){ 
                return("bedit-row-item-full") 
            }else if(small){
                return("bedit-row-item-small")
            }else if(lado){
                    return("bedit-row-item-lado")
                }else if(hor_small){
                    return("bedit-row-item-hor-small")
            }else{
                return("bedit-row-item")
            }       
        }

    return(

            <div className={ getClassItem() } style={{width: width && width, height:height }}>
                { titulo  && <div className="bedit-item-title">{titulo}</div> }
                <select className='bedit-input' type="text"  ref={reef} style={style ? style  : {}} onKeyDown={ (e) => handleEnter(e, next)} 
                 onChange={(e) => { 
                     if(setKey || setAux){
                        let pr = JSON.parse(e.target.value);        
                        setValue(e.target.value); 
                        setKey && setKey(pr.key); 
                        setAux && setAux(pr.aux);
                     }else{
                        setValue(e.target.value); 
                     }
                   
             
                    }} value={value}>
                 <option>Selecione</option> 
                 {children}
                </select>
            </div>
    )
}
     

export const BCombo2 = ({modelo=1, id, name, children, tam="", titulo="", setValue, className,  widthListAuto=true, value, reef, next, cor="white", bordaCor, setKey, width, disabled, 
                         minWidth, autoWidth, multiline, marginTop, height, carregando=false, btnExtraTx="", atencao,
                         btnExtraHint="",btnExtraClick, pulse=true, modoAberto=false, onChange=()=>{}}) => {
 
    const [forcePulse, setForcePulse] = useState(false);

   
    function createClass(mdl){
            let base = "";
            let classe = "";
            //---------------------------------------
            if(mdl == 1){ classe = "bedit-model-1"; }
            else if(mdl == 2){ classe = "bedit-model-2"; }
            else{ classe = "bedit-model-3"; }    
            //---------------------------------------  cor ? cor : null autoComplete={"off"}
            return(classe + " " +base)
        }

        const getValueFromChildren = () => {
            // Implement logic to extract the value from the rendered content
            // This might involve traversing the JSX structure or using a regular expression
            // depending on the format of the rendered content
            return /* extracted value */;
          };
      
    return(
        <BMolder  modelo={modelo} className={className} marginTop={marginTop} combo2="5px" width={width ? width : null} height={height ? height : null}
                minWidth={minWidth} bordaCor={bordaCor} bordaSize={"3px"} cor={cor}
                style={{overflow:"hidden"}} pulse={forcePulse && pulse}
                titulo={titulo && <div style={{display:"flex", justifyContent:"space-between", overflow:"hidden"}}>
                                                                                <p>{titulo}</p>
                                                                                { btnExtraClick && <>
                                                                                <div className='bcombo-btn-extra'  
                                                                                     style={{marginTop:"2px", marginRight:"5px"}} >
                                                                                    <Tooltip title={btnExtraHint} >
                                                                                        <AiFillSetting size={17} onClick={()=> {btnExtraClick();}} />
                                                                                    </Tooltip>
                                                                                </div></>}
                                                                            </div>} disabled={disabled}>
              
                <div style={{ height:"100%", width:"100%", overflow:"hidden", paddingRight: modoAberto ? (modoAberto ? "7px" : 0) : (atencao ? "24px" : "16px"), 
                                    marginLeft: modoAberto ? (modoAberto ? "7px" : 0) :"-11px"}}  autocomplete="off" >  
                    { modoAberto ? <>
                    <div style={{display:"flex", gap:"5px"}}>
                        {children}
                    </div>
                    </> : <>                                                                       
                    <Select name={name} id={id} disabled={disabled}  dropdownMatchSelectWidth={widthListAuto} autocomplete="off" dropdownStyle={{maxWidth:"480px"}}
                        onFocus={(e)=>{setForcePulse(true)}}
                        onBlur={(e)=>{setForcePulse(false)}}
                        className={createClass(modelo ? modelo : 1)+(pulse ? " bmolder-input ": "")}
                        optionFilterProp="children"
                        showSearch
                        loading={carregando} 
                        style={{height:"93%", width:"calc(100% + 28px)", marginTop:"2px", 
                                color:(value == -1 || value == "-1" || value == "") ? "rgb(150, 150, 150)" : null }} type="text" 
                        ref={reef} onKeyDown={ (e) => handleEnter(e, next)} 
                        onChange={(e) => { setValue(e); onChange(e); }} value={value}>
                        {children}
                    </Select></>}
                </div>
                
            </BMolder>
    )

}
export const BComboOp = ({children, modoAberto=false, value={}, check=false, onClick}) => {
    if(modoAberto){
        return(
                <div className={`btn-combo-aberto ${check ? "btn-combo-aberto-check":""}`} value={value} onClick={()=>{ onClick && onClick(value) }}
                     style={{width:"100%", borderRadius:"10px", textAlign:"center",  
                        padding:"4px", cursor:"pointer" }}>{children}</div>       
        );
    }else{
        return(
    
            <Option value={value} ><div style={{width:"250px" ,minWidth:"250px", }}>{children}</div></Option> 
        
        );
    }
 
}

export const BCirc = ({cor="green", cor_b="", left, top, size}) => {
    return(<>
        { cor_b ? <>
            <div className="bcirculo_a" style={{backgroundColor: "white", border: cor_b ? "2px solid "+cor_b : "", }}>
            <div className="bcirculo_b" style={{backgroundColor: cor ? cor : "green",}}/>  
        </div> 
        </> : <>
            <div className="bcirculo" style={{backgroundColor:cor ? cor : "green", marginLeft:left ? left : null, marginTop: top ? top : null, height: size ? size : null, width: size ? size : null}}/> 
        </> }
        </>
    );
}

export const BCheck = ({titulo, full, small, small2, small3, disabled=false, setValue, cor, help="", modelo=1,
                        fundo="rgba(255, 255, 255, 0)", value, reef, next, pulse=false,fontSize, width="auto", textPos="end", onClick=()=>{}}) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);
    // modelo = 1: normal, 2: compacto, 3: split_moderno
    return(
        <BMolder modelo={3} width={width} minWidth={width} height={ modelo == 1 ? '37px' : '29px' }  pulse={pulse} cor={fundo}
                 bordaSize={1}  
                 disabled={disabled} >
                { modelo == 3 ? <>
                    <div style={{display:"flex", gap:"5px", alignItems:"center"}}>
                        <Switch disabled={disabled} onChange={ p => setValue(p) } checked={value} style={{width:"35px",minWidth:"35px",maxWidth:"35px"}} />
                   
                    {textPos == "end" &&  <div className="bedit-item-title-lateral" 
                                                style={{color: cor ? cor : "black", lineHeight: "0.96", marginTop:"1px",
                                                    fontSize:fontSize ? fontSize : modelo == 1 ? "12px" : "11px"}} 
                                            onClick={() => { if(disabled == false){  setValue(!value); onClick(!value) } } }>{titulo}</div>}
                    {String(help).length > 0 && <div style={{marginTop:"4px"}}><Tooltip title={String(help)} 
                                                zIndex={999999}><FaQuestionCircle size={14} color={"rgb(69, 106, 121)"} 
                                                style={{marginLeft:"5px"}}/></Tooltip></div> }    
                    </div>
                </> : <>           
                    <div style={{ display:"flex", height:"100%", width:"100%",alignItems:"center", padding:"5px", borderRadius:"10px" ,
                                    backgroundColor:fundo}}>

                        {textPos == "start" &&  <div className="bedit-item-title-lateral" style={{color: cor ? cor : "black", fontSize:fontSize ? fontSize : "12px" }} 
                                                    onClick={() => {  if(disabled == false){ setValue(!value); onClick(!value) } } }>{titulo}</div>}
                    
                        <input type="checkbox" disabled={disabled} style={{ marginLeft: textPos == "start" ? "5px" :"0px",  marginRight: textPos == "end" ? "5px" :"0px", 
                                                        minHeight:modelo == 1 ? "20px" : "15px", maxHeight:modelo == 1 ? "20px" : "15px", 
                                                        minWidth:modelo == 1 ? "20px" : "15px", maxWidth:modelo == 1 ? "20px" : "15px", 
                                                        }} 
                            onChange={(e) => { if(disabled == false){  setValue(!value); onClick(!value) } }} checked={value} ref={reef} onKeyDown={ (e) => handleEnter(e, next)} 
                        className='bedit-check' id="chk_a35235235tivo" name="chk_ativ2352352o" /> 
                        {textPos == "end" &&  <div className="bedit-item-title-lateral" style={{color: cor ? cor : "black", fontSize:fontSize ? fontSize : modelo == 1 ? "12px" : "11px"}} 
                                                    onClick={() => { if(disabled == false){  setValue(!value); onClick(!value) } } }>{titulo}</div>}
                        {String(help).length > 0 && <div style={{marginTop:"4px"}}><Tooltip title={String(help)} 
                                                zIndex={999999}><FaQuestionCircle size={14} color={"rgb(69, 106, 121)"} 
                                                style={{marginLeft:"5px"}}/></Tooltip></div> }    
                    </div>
                </>}
        </BMolder>
    )

}

// [ {  tipo:"2", filtro_value:"1", filtro_col: "id_aux" } ]




export const BTreeItem = ({children, class_n="", id=-1,  titulo, btn_add_tx, returnClick, }) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);
 
    return(
     
        <li  className={class_n}><div className="tree-titulo" onClick={  returnClick(id)  }>{titulo} 
            <div className="tree-btn-edit"><FiMoreHorizontal size={15} /></div></div>
            { children }
        
        </li>

    )

}


export const BEditIcon = ({setValue, value}) => {
    const [ alterarIcone, setAlterarIcone ] = useState(false);
    const { isMobile } = useContext(AppContext);
    let ta = {offsetTop: "10px", offsetLeft: "10px", offsetLeft: "10px", offsetHeight: "10px"}
    try{
        if(!isObjectEmpty("bediticon-56546010")){
            let itt = document.getElementById("bediticon-56546010");
            if(itt){
                ta = itt;
            }
        }
    }catch{
        //
    }

    return(<>
        
        <BMolder id={"bediticon-56546010"} className={""} combo2="5px" titulo={"Icone"} width={"120px"} >
       
            { safeStr(value).length <= 0 ? <p style={{fontSize:"30px", marginTop:"-8px",  margin:"0", padding:"0"}}>📦</p>
            : <p style={{fontSize:"30px", margin:"0", marginTop:"-8px", padding:"0"}}>{value}</p> }
             
            <BButton texto={"Alterar"} onClick={ ()=>{ setAlterarIcone(!alterarIcone); } } height='25px' />
            
        </BMolder>

        
        { isMobile ? <>
        <div className={"bediticon-picker"} style={{ top:`5px`, left:`5px` }} >
                     { alterarIcone && <EmojiPicker onEmojiClick={(e)=>{ setValue(e.emoji); setAlterarIcone(false); }} /> }        
        </div></>: <>
        <div className={"bediticon-picker"} style={{ top:`calc(${ta.offsetTop} + 120px)`, left:`calc(${ta.offsetLeft} + 350px)` }} >
                     { alterarIcone && <EmojiPicker onEmojiClick={(e)=>{ setValue(e.emoji); setAlterarIcone(false); }} /> }        
        </div></>}



        </>
    )
}

function convertCorToRgb(cor){
    if(cor.length <= 6){
        if(cor == "black"){
            return "rgb(15, 15, 15)";
        }else if(cor == "black"){
            return "rgb(15, 15, 15)";
        }else if(cor == "blue"){
            return "rgb(17, 23, 220)";
        }else if(cor == "green"){
            return "rgb(23, 196, 0)";
        }else if(cor == "orange"){
            return "rgb(235, 106, 0)";
        }else if(cor == "red"){
            return "rgb(236, 0, 0)";
        }else if(cor == "yellow"){
            return "rgb(224, 221, 41)";
        }else if(cor == "gray"){
            return "rgb(104, 104, 104)";
        }else if(cor == "white"){
            return "rgb(255, 255, 255)";
        }else if(cor == "pink"){
            return "rgb(249, 21, 181)";
        }else if(cor == "purple"){
            return "rgba(176, 16, 216, 1)";
        }else if(cor == "grey"){
            return "rgb(81, 81, 81)";
        }
    }
    return cor;
}



export const BToggle = ({height="29px", width="100px", itens=[], value=-1, setValue=()=>{}, fundo="rgb(255, 255, 255)", borda=true,
                         color="black", corFontDis="black" }) => {
    return(<>       
        <div style={{ minWidth: width, height: height, border: borda ? "1px solid rgb(98, 98, 98)" : null, 
                      borderRadius:"5px", padding:"2px", display:"flex", gap:"2px",
           
                      margin:0, flexDirection:"row", backgroundColor: fundo, 
                      alignItems:"center", justifyContent:"center", color:color }}>
            { itens.length > 0 ? <>
                { itens.map(a => <div style={{color:corFontDis}}
                    className={`b-toggle-btn ${ value == a.value ? "b-toggle-sel" : "" } `} onClick={()=>{setValue(a.value)}}>{a.label}</div>) }
            </>:<p>Sem Itens</p> }
        </div>
    </>)
    
}


export const B2Button = ({height="100px", width="100px", disabled=false, texto, bt1_icon, bt1_hint, bt1_click = ()=>{}, bt2_icon, bt2_hint, bt2_click = ()=>{}}) => {
 
    return(<>       
        <div style={{ minWidth: width, height: height, border:"1px solid rgb(186, 201, 216)", borderRadius:"5px", display:"flex", 
                      margin:0, flexDirection:"column", backgroundColor: disabled ? "rgb(173, 186, 192)" : "rgb(237, 237, 237)" }}>
            <p style={{minWidth: width, display:"flex",alignItems:"center", justifyContent:"center",  marginTop:"0px", minHeight:"14px", 
                        color : disabled ? "rgb(100, 100, 100)" : "black" ,
                       height:"100%",fontSize: "12px", overflow:"hidden", paddingRight:"10px", paddingLeft:"10px"}}>{texto}</p>
            <div style={{minWidth: width, display:"flex", margin:0, justifyContent:"center", height:"100%",}}>
                <Tooltip title={disabled ? "" : bt1_hint}>
                <div className={disabled ? "" : 'b2button-btn'} style={{borderTop:"1px solid rgb(222, 229, 236)", borderRight:"1px solid rgb(193, 201, 208)",  borderEndStartRadius:"5px", 
                            backgroundColor:disabled ? "rgb(173, 186, 192)" :"rgb(99, 130, 143)", 
                            color:"white", width:"100%", height:"100%", display:"flex", justifyContent:"center", alignItems:"center", cursor:disabled ? "default" : "pointer"}} 
                    onClick={() => { !disabled && bt1_click() }} texto={bt1_hint} txTipo={'hint'} >{bt1_icon ? bt1_icon : null}</div>
                </Tooltip>
                <Tooltip title={ disabled ? "" : bt2_hint}>
                <div className={disabled ? "" : 'b2button-btn'} style={{borderTop:"1px solid rgb(222, 229, 236)",  borderEndEndRadius:"5px", 
                            backgroundColor:disabled ? "rgb(173, 186, 192)" :"rgb(99, 130, 143)", 
                            color:"white", width:"100%", height:"100%", display:"flex", justifyContent:"center", alignItems:"center", cursor:disabled ? "default" : "pointer"}} 
                    onClick={() => { !disabled && bt2_click() }} texto={bt2_hint} txTipo={'hint'} >{bt2_icon ? bt2_icon : null}</div>
                </Tooltip>
            </div>
        </div>
    </>)
    
}

export const B3Button = ({height="100px", width="100px", disabled=false, texto, bt1_icon, bt1_hint, bt1_click = ()=>{}, bt2_icon, bt2_hint, bt2_click = ()=>{}, 
                          bt3_icon, bt3_hint, bt3_click = ()=>{}}) => {
 
    return(<>       
        <div style={{ minWidth: width, height: height, border:"1px solid rgb(186, 201, 216)", borderRadius:"5px", display:"flex", 
                      margin:0, flexDirection:"column", backgroundColor: disabled ? "rgb(173, 186, 192)" : "rgb(237, 237, 237)" }}>
            <p style={{minWidth: width, display:"flex",alignItems:"center", justifyContent:"center",  
                color : disabled ? "rgb(100, 100, 100)" : "black" ,
                marginTop:"0px", minHeight:"14px",  height:"100%",fontSize:"12px", overflow:"hidden"}}>{texto}</p>
            <div style={{minWidth: width, display:"flex", margin:0, justifyContent:"center", height:"100%",}}>
                <Tooltip title={disabled ? "" : bt1_hint}>
                <div className={disabled ? "" : 'b2button-btn'} style={{borderTop:"1px solid rgb(222, 229, 236)", borderRight:"1px solid rgb(193, 201, 208)",  borderEndStartRadius:"5px", 
                            backgroundColor: disabled ? "rgb(173, 186, 192)" : "rgb(99, 130, 143)", 
                            color:"white", width:"100%", height:"100%", display:"flex", justifyContent:"center", alignItems:"center", cursor: disabled ? "default" : "pointer"}} 
                    onClick={() => { !disabled && bt1_click() }} texto={bt1_hint} txTipo={'hint'} >{bt1_icon ? bt1_icon : null}</div>
                </Tooltip>
                <Tooltip title={disabled ? "" : bt2_hint}>
                <div className={disabled ? "" : 'b2button-btn'} style={{borderTop:"1px solid rgb(222, 229, 236)", borderRight:"1px solid rgb(193, 201, 208)",
                            backgroundColor: disabled ? "rgb(173, 186, 192)" : "rgb(99, 130, 143)", 
                            color:"white", width:"100%", height:"100%", display:"flex", justifyContent:"center", alignItems:"center", cursor:disabled ? "default" : "pointer"}} 
                    onClick={() => { !disabled && bt2_click() }} texto={bt2_hint} txTipo={'hint'} >{bt2_icon ? bt2_icon : null}</div>
                </Tooltip>
                <Tooltip title={disabled ? "" : bt3_hint}>
                <div className={disabled ? "" : 'b2button-btn'} style={{borderTop:"1px solid rgb(222, 229, 236)",  borderEndEndRadius:"5px", 
                            backgroundColor: disabled ? "rgb(173, 186, 192)" : "rgb(99, 130, 143)", 
                            color:"white", width:"100%", height:"100%", display:"flex", justifyContent:"center", alignItems:"center", cursor:disabled ? "default" : "pointer"}} 
                    onClick={() => { !disabled && bt3_click() }} texto={bt3_hint} txTipo={'hint'} >{bt3_icon ? bt3_icon : null}</div>
                </Tooltip>
            </div>
        </div>
    </>)
    
}

export const BButton = ({icon,  fundo="rgb(250, 254, 255)", cor="black", sel="blue", padding, name, fontSize="1.06rem",
                        borda=true, bordaCor="rgb(183, 183, 183)", bordaSize=1, texto, novaAba=false, emAlerta=false, keyAction="", keyActionDouble=true, action,
                        height="37px", width="auto", minWidth, disabled, carregando=false, check=false, marginLeft, semFoco=false,
                        onClick=()=>{}, txTipo, iconPos="start", to, help=""}) => {

    const { fatVencida } = useContext(AppContext);
               
    let bordaSizeTmp = bordaSize;
    if(check){
        bordaSizeTmp += 1;
    }

    //const brd = String(bordaSize)+"px solid "+((disabled || carregando) ? "grey": check ? sel : bordaCor);
    const corr = String(((disabled || carregando) ? "grey": check ? sel : convertCorToRgb(bordaCor) ))
    const cor_fraca = corr.replace("rgb","rgba").replace(")",", 0.4)")
    const brd =  String(bordaSize)+"px solid "+cor_fraca;
    const brd2 =  String(bordaSizeTmp)+"px solid "+corr;
  //  border: 1px solid  rgb(239, 239, 239);
  //  border-bottom: 1px solid rgb(202, 202, 202);

    const [isKeyPressed, setIsKeyPressed] = useState(false);
    const [qtdPress, setQtdPress] = useState(0);

    useEffect(() => {
        setQtdPress(0);
    }, []);


    const TimerActionComponent = ({keyAction="", double=true, isKeyPressed, setIsKeyPressed, action=()=>{} }) => {
        useEffect(() => {
            let timeoutId;

            let keysAction = keyAction && keyAction.length > 0 ? (keyAction.includes(",") ? String(keyAction).split(",") : [keyAction]) : []
    
            const handleKey = (event) => {
                
                //toast.error(String(keysAction))
                if(keysAction.includes(event.key)){   
                    //toast.success("A")
                    if(double){
                        setQtdPress(qtdPress+1); 
                        if(!timeoutId){
                            if(qtdPress >= 1){
                                clearTimeout(timeoutId);
                                setIsKeyPressed(false);
                                setQtdPress(0); 
                          
                                action();
                            }else if(qtdPress == 0){
                                setIsKeyPressed(true);
                                timeoutId = setTimeout(() => {   
                                    clearTimeout(timeoutId);
                                    setIsKeyPressed(false);
                                    setQtdPress(0); 
                                }, 400);
                            }              
                        }
                    }else{
                        clearTimeout(timeoutId);
                        setIsKeyPressed(false);
                        setQtdPress(0); 
                        action();
                    }
                }
            };
            
        
            window.addEventListener('keyup', handleKey);  
            return () => { 
                window.removeEventListener('keyup', handleKey);
            // clearTimeout(timeoutId);
            };
        }, []);
  
        return(<></>);
    };



    const idTemp = Math.random();
    //TIPO: hint hide check hide/check
    // Na altura Heigth usar numeros PAREDS sempre 28 , 40 , 20 , 22 , 24
    return(<>
    {
     
    keyAction && safeStr(keyAction).length >= 1 ? <TimerActionComponent 
    keyAction={keyAction} 
    double={keyActionDouble}
    isKeyPressed={isKeyPressed} setIsKeyPressed={setIsKeyPressed} action={ () => { action() }} /> : null
    
    }

        { (fatVencida || disabled || carregando) ? 
        <>
            <BSpinDiv item_pai={"div-"+idTemp} style={{ marginLeft: "3px", height: height, width: width, paddingLeft: padding ? padding : null, marginLeft : marginLeft ? marginLeft : null, 
                         paddingRight: padding ? padding : null, }} texto={""}  display={carregando ? true : false} carregando={carregando} opacidade={"0.3"}>
            { texto && txTipo == "hint" ?
                <button id={idTemp} className="b-button" onClick={onClick} tabIndex={semFoco ? "-1" : null}
                    style={{ fontSize:fontSize , height: height,lineHeight: "14px", width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                    color:"grey", border: borda? brd : 'none', backgroundColor: fundo }} disabled={true}> {icon && <div className="b-button-icon" >{icon}</div>}
                </button> 
            : texto && txTipo == "hide" ?
                    <button id={idTemp} className="b-button b-button-tx-auto-hide" onClick={onClick} tabIndex={semFoco ? "-1" : null}
                        style={{fontSize:fontSize ,lineHeight: "14px",  height: height, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                        color:"grey", border: borda? brd : 'none', backgroundColor: fundo }} disabled={true}>{icon && <div className="b-button-icon">{icon}</div>}
                        <div className="txtx" >{texto}</div>      
                    </button>
            
                : texto && txTipo == "hide/check" ?
                    <button id={idTemp} className={`b-button ${ !check && "b-button-tx-auto-hide"  } `} onClick={onClick} tabIndex={semFoco ? "-1" : null}
                        style={{fontSize:fontSize ,  height: height,lineHeight: "14px", width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                        color:"grey", border: borda? brd : 'none', backgroundColor: fundo }} disabled={true}>{icon && <div className="b-button-icon">{icon}</div>}              
                        { check ? <div className="b-button-texto">{texto}</div> : <div className="txtx" >{<div className="b-button-texto">{texto}</div>}</div>    }                                      
                    </button>
                    :
                    <button id={idTemp} className="b-button" onClick={onClick} tabIndex={semFoco ? "-1" : null}
                        style={{fontSize:fontSize , lineHeight: "14px", height: height, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                        color:"grey", border: borda? brd : 'none', backgroundColor: fundo }} disabled={true}>{icon && <div className="b-button-icon">{icon}</div>}
                        { texto ? ( txTipo == "check" ? ( check ? <div className="b-button-texto">{texto}</div> : null ) : (<div className="b-button-texto">{texto}</div>) ) : null }                     
                    </button>
            }
            {fatVencida && <div style={{height:"100%", width:"100%", backgroundColor:"rgba(201, 75, 75, 0.18)", borderRadius:"20px", 
                                        position:"absolute", top:0, display:"flex", alignItems:"center", justifyContent:"center"}}>
                                            <Tooltip title={"Recurso bloqueado"} >
                                            <ImBlocked color='red' size={20} />
                                            </Tooltip>
                
            </div>}
            </BSpinDiv></>
            :
            <>
            { texto && txTipo == "hint" ?
            <> 
           
                { to ?  <Tooltip title={texto}>
                    <Link id={idTemp} className="b-button b-normal" onClick={onClick} target={novaAba ? "_blank" : null} to={to} name={name ? name : null} tabIndex={semFoco ? "-1" : null}
                        style={{fontSize:fontSize ,  height: height, width: width, paddingLeft: 0, paddingRight: 0,
                        color:cor, borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none', backgroundColor: fundo }} >{icon && <div className="b-button-icon" >{icon}</div>}
                    </Link> 
                </Tooltip> : <Tooltip title={texto}> 
                    <button id={idTemp} className="b-button b-normal" onClick={onClick} name={name ? name : null} tabIndex={semFoco ? "-1" : null}
                        style={{ fontSize:fontSize, height: height, width: width, 
                                 paddingLeft: 0, paddingRight: 0, alignItems:"center", justifyContent:"center",
                        color: cor, lineHeight: "14px",
                        borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none', 
                         backgroundColor: fundo }} >{icon && <div className="b-button-icon" style={{marginRight:"0px"}}>{icon}</div>}
                    </button> 
                    </Tooltip>  }              
            </>           
            : texto && txTipo == "hide" ?
                    to ? <>
                        <Link id={idTemp} className="b-button b-normal b-button-tx-auto-hide" onClick={onClick} target={novaAba ? "_blank" : null} to={to} name={name ? name : null} tabIndex={semFoco ? "-1" : null}
                            style={{fontSize:fontSize ,  height: height, marginLeft : marginLeft ? marginLeft : null, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color:cor, borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none', 
                             backgroundColor: fundo }} >{icon && <div className="b-button-icon">{icon}</div>} 
                            <div className="txtx" >{texto}</div>      
                        </Link>
                    </> : <>
                        <button id={idTemp} className="b-button b-normal b-button-tx-auto-hide" onClick={onClick}  name={name ? name : null} tabIndex={semFoco ? "-1" : null}
                            style={{ fontSize:fontSize , height: height,marginLeft : marginLeft ? marginLeft : null,  width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color:cor, borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', lineHeight: "14px", borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none', 
                             backgroundColor: fundo }} >{icon && <div className="b-button-icon">{icon}</div>}
                            <div className="txtx" >{texto}</div>      
                        </button>
                    </> 
                : texto && txTipo == "hide/check" ?
                    to ? <>
                        <Link id={idTemp} className={`b-button b-normal ${ !check && " b-button-tx-auto-hide"  } `} tabIndex={semFoco ? "-1" : null} onClick={onClick} target="_blank" to={to} name={name ? name : null}
                            style={{fontSize:fontSize ,  height: height,marginLeft : marginLeft ? marginLeft : null,  width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color:cor, 
                            borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none',  backgroundColor: fundo }} >{icon && <div className="b-button-icon">{icon}</div>}                 
                            { check ? texto : <div className="txtx" >{texto}</div>    }                                      
                        </Link>
                    </> : <>
                        <button id={idTemp} className={`b-button b-normal ${ !check && " b-button-tx-auto-hide"  } `} tabIndex={semFoco ? "-1" : null} onClick={onClick} name={name ? name : null}
                            style={{fontSize:fontSize ,  height: height, marginLeft : marginLeft ? marginLeft : null, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color: cor, lineHeight: "14px",
                            borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none'
                            , backgroundColor: fundo }} >{icon && <div className="b-button-icon">{icon}</div>}                 
                            { check ? texto : <div className="txtx" >{texto}</div>    }                                      
                        </button>
                    </> 
                    :
                    to ? <>
                        <Link id={idTemp} className={`b-button b-normal `} onClick={onClick} target={novaAba ? "_blank" : null} tabIndex={semFoco ? "-1" : null} to={to} name={name ? name : null}
                            style={{fontSize:fontSize ,  height: height, marginLeft : marginLeft ? marginLeft : null, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color:cor, border: borda? brd : 'none', backgroundColor: fundo }} >{icon && <div className="b-button-icon">{icon}</div>}
                            { texto ? ( txTipo == "check" ? ( check ? <div className="b-button-texto">{texto}</div> : null ) : (<div className="b-button-texto">{texto}</div>) ) : null }                     
                        </Link>
                    </> : <> 
                        <button id={idTemp} 
                            className={"b-button b-normal "+(isKeyPressed ? " b-anima " : "")+" "+(emAlerta ? " b-button-borda " : "") } 
                            tabIndex={semFoco ? "-1" : null} onClick={onClick} name={name ? name : null} 
                            style={{fontSize:fontSize , height: height, width: width, minWidth: minWidth ? minWidth : null,  lineHeight: "14px",
                                    marginLeft : marginLeft ? marginLeft : null, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color: cor, 
                           
                            borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none', 
                            
                            
                            backgroundColor: fundo }} >{icon && iconPos == "start" && <div className="b-button-icon" style={{}}>{icon}</div>}
                            { texto ? ( txTipo == "check" ? ( check ? <div className="b-button-texto">{texto}</div> : null ) : 
                                                            (<div className="b-button-texto" style={{}}>{texto}</div>) ) : null }   
                            {icon && iconPos == "end" && <div className="b-button-icon-end" style={{}}>{icon}</div>}  
                            {String(help).length > 0 && <div><Tooltip title={String(help)} 
                                        zIndex={999999}><FaQuestionCircle size={14} color={"rgb(69, 106, 121)"} 
                                        style={{marginLeft:"5px"}}/></Tooltip></div> }                
                        </button>
                    </>
            }
            </>
        }
        
    </>)

}


export const BButtonCheck = ({icon, fundo="rgb(250, 254, 255)", cor="black", sel="blue", padding, name, fontSize="12px",
                        borda=true, bordaCor="rgb(183, 183, 183)", bordaSize=1, texto, novaAba=false, emAlerta=false, keyAction="", action,
                        height="37px", width="auto", disabled, carregando=false, check=false, marginLeft, semFoco=false,
                        onClick=()=>{}, txTipo, to}) => {

    let bordaSizeTmp = bordaSize;
    if(check){
        bordaSizeTmp += 2;
    }

    const idTemp = Math.random();

    //const brd = String(bordaSize)+"px solid "+((disabled || carregando) ? "grey": check ? sel : bordaCor);
    const corr = String(((disabled || carregando) ? "grey": check ? sel : convertCorToRgb(bordaCor) ))
    const cor_fraca = corr.replace("rgb","rgba").replace(")",", 0.4)")
    const brd =  String(bordaSize)+"px solid "+cor_fraca;
    const brd2 =  String(bordaSizeTmp)+"px solid "+corr;
  //  border: 1px solid  rgb(239, 239, 239);
  //  border-bottom: 1px solid rgb(202, 202, 202);

    //TIPO: hint hide check hide/check
    // Na altura Heigth usar numeros PAREDS sempre 28 , 40 , 20 , 22 , 24
    return(<>
        { (disabled || carregando) ? 
        <>
            <BSpinDiv item_pai={"div-"+idTemp} style={{ marginLeft: "3px", height: height, width: width, paddingLeft: padding ? padding : null, marginLeft : marginLeft ? marginLeft : null, 
                         paddingRight: padding ? padding : null, }} texto={""}  display={carregando ? true : false} carregando={carregando} opacidade={"0.3"}>
            { texto && txTipo == "hint" ?
                <button id={idTemp} className="b-button" onClick={onClick} tabIndex={semFoco ? "-1" : null}
                    style={{ fontSize:fontSize , height: height, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                    color:"grey", border: borda? brd : 'none', backgroundColor: fundo }} disabled={true}> {icon && <div className="b-button-icon" >{icon}</div>}
                </button> 
            : texto && txTipo == "hide" ?
                    <button id={idTemp} className="b-button b-button-tx-auto-hide" onClick={onClick} tabIndex={semFoco ? "-1" : null}
                        style={{fontSize:fontSize ,  height: height, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                        color:"grey", border: borda? brd : 'none', backgroundColor: fundo }} disabled={true}>{icon && <div className="b-button-icon">{icon}</div>}
                        <div className="txtx" >{texto}</div>      
                    </button>
            
                : texto && txTipo == "hide/check" ?
                    <button id={idTemp} className={`b-button ${ !check && "b-button-tx-auto-hide"  } `} onClick={onClick} tabIndex={semFoco ? "-1" : null}
                        style={{fontSize:fontSize ,  height: height, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                        color:"grey", border: borda? brd : 'none', backgroundColor: fundo }} disabled={true}>{icon && <div className="b-button-icon">{icon}</div>}              
                        { check ? <div className="b-button-texto">{texto}</div> : <div className="txtx" >{<div className="b-button-texto">{texto}</div>}</div>    }                                      
                    </button>
                    :
                    <button id={idTemp} className="b-button" onClick={onClick} tabIndex={semFoco ? "-1" : null}
                        style={{fontSize:fontSize ,  height: height, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                        color:"grey", border: borda? brd : 'none', backgroundColor: fundo }} disabled={true}>{icon && <div className="b-button-icon">{icon}</div>}
                        { texto ? ( txTipo == "check" ? ( check ? <div className="b-button-texto">{texto}</div> : null ) : (<div className="b-button-texto">{texto}</div>) ) : null }                     
                    </button>
            }
            </BSpinDiv></>
            :
            <>
            { texto && txTipo == "hint" ?
            <> 
           
                { to ?  <Tooltip title={texto}>
                    <Link id={idTemp} className="b-button" onClick={onClick} target={novaAba ? "_blank" : null} to={to} name={name ? name : null} tabIndex={semFoco ? "-1" : null}
                        style={{fontSize:fontSize ,  height: height, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                        color:cor, borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none', backgroundColor: fundo }} >{icon && <div className="b-button-icon" >{icon}</div>}
                    </Link> 
                </Tooltip> : <Tooltip title={texto}> 
                    <button id={idTemp} className="b-button" onClick={onClick} name={name ? name : null} tabIndex={semFoco ? "-1" : null}
                        style={{ fontSize:fontSize, height: height, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                        color: cor, 
                        borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none', 
                         backgroundColor: fundo }} >{icon && <div className="b-button-icon"style={{marginRight:"2px"}}>{icon}</div>}
                    </button> 
                    </Tooltip>  }              
            </>           
            : texto && txTipo == "hide" ?
                    to ? <>
                        <Link id={idTemp} className="b-button b-button-tx-auto-hide" onClick={onClick} target={novaAba ? "_blank" : null} to={to} name={name ? name : null} tabIndex={semFoco ? "-1" : null}
                            style={{fontSize:fontSize ,  height: height, marginLeft : marginLeft ? marginLeft : null, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color:cor, borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none', 
                             backgroundColor: fundo }} >{icon && <div className="b-button-icon">{icon}</div>} 
                            <div className="txtx" >{texto}</div>      
                        </Link>
                    </> : <>
                        <button id={idTemp} className="b-button b-button-tx-auto-hide" onClick={onClick}  name={name ? name : null} tabIndex={semFoco ? "-1" : null}
                            style={{ fontSize:fontSize , height: height,marginLeft : marginLeft ? marginLeft : null,  width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color:cor, borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none', 
                             backgroundColor: fundo }} >{icon && <div className="b-button-icon">{icon}</div>}
                            <div className="txtx" >{texto}</div>      
                        </button>
                    </> 
                : texto && txTipo == "hide/check" ?
                    to ? <>
                        <Link id={idTemp} className={`b-button ${ !check && " b-button-tx-auto-hide"  } `} tabIndex={semFoco ? "-1" : null} onClick={onClick} target="_blank" to={to} name={name ? name : null}
                            style={{fontSize:fontSize ,  height: height,marginLeft : marginLeft ? marginLeft : null,  width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color:cor, 
                            borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none',  backgroundColor: fundo }} >{icon && <div className="b-button-icon">{icon}</div>}                 
                            { check ? texto : <div className="txtx" >{texto}</div>    }                                      
                        </Link>
                    </> : <>
                        <button id={idTemp} className={`b-button ${ !check && " b-button-tx-auto-hide "  } `} tabIndex={semFoco ? "-1" : null} onClick={onClick} name={name ? name : null}
                            style={{fontSize:fontSize ,  height: height, marginLeft : marginLeft ? marginLeft : null, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color: cor, 
                            borderTop: borda? brd : 'none', borderLeft: borda? brd : 'none', borderRight: borda? brd : 'none', borderBottom: borda? brd2: 'none'
                            , backgroundColor: fundo }} >{icon && <div className="b-button-icon">{icon}</div>}                 
                            { check ? texto : <div className="txtx" >{texto}</div>    }                                      
                        </button>
                    </> 
                    :
                    to ? <>
                        <Link id={idTemp} className={`b-button  `} onClick={onClick} target={novaAba ? "_blank" : null} tabIndex={semFoco ? "-1" : null} to={to} name={name ? name : null}
                            style={{fontSize:fontSize ,  height: height, marginLeft : marginLeft ? marginLeft : null, width: width, paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                            color:cor, border: borda? brd : 'none', backgroundColor: fundo }} >{icon && <div className="b-button-icon">{icon}</div>}
                            { texto ? ( txTipo == "check" ? ( check ? <div className="b-button-texto">{texto}</div> : null ) : (<div className="b-button-texto">{texto}</div>) ) : null }                     
                        </Link>
                    </> : <> 
                        <button id={idTemp} 
                            className={"b-button "+(emAlerta ? " b-button-borda " : "") } 
                            tabIndex={semFoco ? "-1" : null} onClick={onClick} name={name ? name : null} 
                            style={{fontSize:fontSize , height: height, width: width, marginLeft : marginLeft ? marginLeft : null, 
                                paddingLeft: padding ? padding : null, paddingRight: padding ? padding : null,
                                color: cor,  
                                borderTop: borda? (check ? brd2: brd ): 'none', 
                                borderLeft: borda? brd : 'none', 
                                borderRight: borda? brd : 'none', 
                                borderBottom: borda ? brd: 'none',                   
                                backgroundColor: check == true ? "#E9EEF3" : fundo }} >{icon && <div className="b-button-icon" style={{}}>{icon}</div>}
                            { texto ? ( txTipo == "check" ? ( check ? <div className="b-button-texto" >{texto}</div> : null ) : 
                                                            (<div className="b-button-texto" >{texto}</div>) ) : null }                     
                        </button>
                    </>
            }
            </>
        }
        
    </>)

}

function strOrVar(strVar, varVar)
{
let res = strVar;
    if(strVar == "@ID"){
        res = varVar;
    }
return res;
}


export const BTree = ({children, itens, returnClick, 
                        c1_add="", c1_filter_1 = "", c1_filter_1_v = "",  c1_filter_2 = "", c1_filter_2_v = "",  c1_filter_3 = "", c1_filter_3_v = "",
                        c2_add="", c2_filter_1 = "", c2_filter_1_v = "",  c2_filter_2 = "", c2_filter_2_v = "",  c2_filter_3 = "", c2_filter_3_v = "",
                        c3_add="", c3_filter_1 = "", c3_filter_1_v = "",  c3_filter_2 = "", c3_filter_2_v = "",  c3_filter_3 = "", c3_filter_3_v = "",
                        c4_add="", c4_filter_1 = "", c4_filter_1_v = "",  c4_filter_2 = "", c4_filter_2_v = "",  c5_filter_3 = "", c4_filter_3_v = "",
                    }) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);
    return(
            <div className="grupos-lista-fundo">
                <ul className="grupos-lista">
                    {<>
                        { c1_filter_1.length > 0 ? 
                        itens.filter((ite) => (c1_filter_1? ite[c1_filter_1] == c1_filter_1_v : ""=="")
                                            &&(c1_filter_2? ite[c1_filter_2] == c1_filter_2_v : ""=="") 
                                            &&(c1_filter_3? ite[c1_filter_3] == c1_filter_3_v : ""=="")).map((ite) => {return(
                            <BTreeItem titulo={ite.nome} btn_add_tx={c1_add} id={ite.id} returnClick={returnClick()}>
                                { c2_filter_1.length > 0 ? 
                                    itens.filter((ite2) => (c2_filter_1? ite2[c2_filter_1] == strOrVar(c2_filter_1_v, ite.id) : ""=="")
                                                         &&(c2_filter_2? ite2[c2_filter_2] == strOrVar(c2_filter_2_v, ite.id) : ""=="") 
                                                         &&(c2_filter_3? ite2[c2_filter_3] == strOrVar(c2_filter_3_v, ite.id) : ""=="")).map((ite2) => {return(
                                        <BTreeItem class_n="sub" titulo={ite2.nome} btn_add_tx={c2_add} id={ite2.id}>
                                            { c3_filter_1.length > 0 ? 
                                                itens.filter((ite3) => (c3_filter_1? ite3[c3_filter_1] == strOrVar(c3_filter_1_v, ite2.id) : ""=="")
                                                                     &&(c3_filter_2? ite3[c3_filter_2] == strOrVar(c3_filter_2_v, ite2.id) : ""=="") 
                                                                     &&(c3_filter_3? ite3[c3_filter_3] == strOrVar(c3_filter_3_v, ite2.id) : ""=="")).map((ite3) => {return(
                                                    <BTreeItem class_n="sub_2" titulo={ite3.nome} btn_add_tx={c3_add} id={ite3.id}>
                                                        { children }           
                                                    </BTreeItem> 
                                                )})                                   
                                                : <></>
                                            }    
                                            <li className="sub_2 tree_add_green">+ Adicionar {c3_add}</li>              
                                        </BTreeItem> 
                                    )})                                   
                                    : <></>
                                }      
                                <li className="sub tree_add_green">+ Adicionar {c2_add}</li>       
                            </BTreeItem> 
                        )})                                   
                        : <></>
                       
                    }            
                    <li className="tree_add_green">+ Adicionar {c1_add}</li>   
                                                                                                  
                    </>}
                </ul>

            </div>
    )

}

//----------------------------------------------------------------------------------------------------------------------------
 //----------------------------------------------------------------------------------------------------------------------------
 //----------------------------------------------------------------------------------------------------------------------------




export const BIcon = ({icon=1,title="", size="18px", cor="black", onClick = () => {}}) =>{
    //'#08c'
    //() => { setItemSel(e.id); setShowEdit(true);

    const i_1 = <SearchOutlined style={{ fontSize: size, color: cor, margin: "4px",
                cursor: onClick ? 'pointer' : 'default' }} 
                onClick={onClick}/>

                const i_2 = <LikeFilled   style={{ fontSize: size, color: cor, margin: "4px",
                cursor: onClick ? 'pointer' : 'default' }} 
                onClick={onClick}/>

                const i_3 = <LikeOutlined style={{ fontSize: size, color: cor, margin: "4px",
                cursor: onClick ? 'pointer' : 'default' }} 
                onClick={onClick}/>

                const i_4 = <DeleteFilled style={{ fontSize: size, color: cor, margin: "4px",
                cursor: onClick ? 'pointer' : 'default' }} 
                onClick={onClick}/>

                const i_5 = <DeleteOutlined style={{ fontSize: size, color: cor, margin: "4px",
                cursor: onClick ? 'pointer' : 'default' }} 
                onClick={onClick}/>

    return(<>
        <Tooltip title={title}>
            { icon == 1 && i_1 }
            { icon == 2 && i_2 }
            { icon == 3 && i_3 }
            { icon == 4 && i_4 }
            { icon == 5 && i_5 }
        </Tooltip>
    </>)
}


export const BMenuContext = ({children, className="", click=null, visivel=false }) => {
    //const { signIn, loading, setUser, user } = useContext(AppContext);

    const [anchorPoint, setAnchorPoint] = useState({ x: "0px", y: "0px" });
    const [show, setShow] = useState(false);

    let xPos ="";
    let yPos ="";

      document.addEventListener("contextmenu",
        useCallback(
          (event) => {
            event.preventDefault();
          
                xPos =(event.pageX -15) + "px";
                yPos =(event.pageY -15) + "px";
                setAnchorPoint({ x: xPos, y: yPos });
           
          },
          [setAnchorPoint]
        )
      );


    return(
        <>
     { visivel ?
        <div  className={"btec-menu-context "+className} style={{ top: anchorPoint.y, left: anchorPoint.x }}  onClick={ () => { click && click() }}>
          <ul className="btec-menu-context-list">
            { children }    
          </ul>
        </div>
        :
        <></>
    }
    </>
    )

}

export const BMenuContextItem = ({children, className="", click=null }) => {

    return(
     
        <li className={"btec-menu-context-item "+className}> 
            <button className="btec-menu-context-item-btn" onClick={ () => { click && click() }}>      
            { children } 
            </button>      
        </li>

    )

}

export const BDisplayComparador = ({titulo = "", hint="", total=0.0, style={} , itens=[{}], fundo, border, onClick}) => {


    function itemCompare(width, cor, titulo, valor, tipo, hint){


        return(<>
        <Tooltip title={hint ? titulo+": "+safeStr(hint) : ""}>

            <div className={"btec-display-comparador-content"} style={{ width:width, padding:0, cursor:"pointer", borderLeft:"1px solid white"}} 
                    onClick={ ()=> onClick ? onClick({cor: cor, titulo: titulo, valor: valor, tipo: tipo}) : null } >  
                           
                <div className={"btec-display-comparador-titulo"} style={{color:"black", marginTop:"-3px", paddingLeft:"2px", borderLeft:"3px solid "+cor}} > 
                    {titulo} 
                </div>
                <div className={"btec-display-comparador-valor"} style={{color:"black", borderLeft:"2px solid "+cor, paddingLeft:"3px"}} > 
                        
                </div>
                <div className={"btec-display-comparador-bar"} 
                     style={{backgroundColor:cor, height:"21px", width:"100%", marginTop:"0px", display:"flex", alignItems:"center", paddingTop:"2px",
                             paddingLeft:"6px", color:"white", fontSize:"13px", fontWeight:600, borderLeft:"1px solid "+cor }} >  
                    {valor}
                </div>   
            </div></Tooltip>
        </>)
    }

    function calcWh(T,V){
        let P = (parseFloat(V) / parseFloat(T)) * 100;
        if(P <= 8){
            P = 8
        }
        return(String(P)+"%");
    }

    function tipoToCor(tipo){
        let tx = tipo.toLowerCase();
        if(tx.includes("cartão")){  return("rgb(0, 81, 181)") }
        if(tx.includes("débito")){  return("rgb(0, 81, 181)") }
        if(tx.includes("crédito")){  return("rgb(105, 126, 0)") }
        if(tx.includes("convênio")){  return("rgb(181, 0, 78)") }
        if(tx.includes("delivery")){  return("rgb(121, 57, 15)") }
        if(tx.includes("ficha") || tx.includes("conta")){  return("orange") }
        if(tx.includes("dinheiro")){  return("green") }
        if(tx.includes("cheque")){  return("red") }
        if(tx.includes("boleto")){  return("purple") }
        if(tx.includes("deposito") || tx.includes("depósito")){  return("gray") }
        if(tx.includes("pix")){  return("rgb(0, 170, 153)") }
        if(tx.includes("outros")){  return("rgb(129, 148, 5)") }
        if(tx.includes("vale") || tx.includes("presente" || tx.includes("gift"))){  return("rgb(39, 45, 43)") }
        return("black");
    }

    return(<>
        { isObjectEmpty(itens) == false && <> 
       
            <div className={"btec-display-comparador-box"} 
                style={{...style, width:"100%", minHeight:"44px", margin:0, padding:"3px", backgroundColor: fundo ? fundo : null, border: border ? border : null  }} > 
                { itens.map( e => { return( itemCompare(calcWh(total, e.total), tipoToCor(e.nome), e.nome, floatToReal(parseFloat(e.total)), e.id_tipo_pag, hint) ) }) }

            </div>
        </>}
    </>)

}

export const BDisplayGrid = ({children, height="", cols=8, style}) => {
    return(
        <div className={"btec-display-grid"} style={{...style, height:height.length >= 2 ? height : "auto", gridTemplateColumns: "repeat("+cols+", 82px)"}}> 
            {children}
        </div>
    )
}

export const BDisplayValor = ({titulo = "", hint, help, valor = "0,00", cor="#605873", tipo="valor", borda, fundo, tag=true, limit=13,  width, minWidth, onClick }) => {
    const estilo = {
        backgroundColor: cor,
        
    }

    function trataT(tx="", tp){
        let res = tx;
        if(tp == "valor"){
        
        }else if(tp == "qtd"){
            if(res.length == 3){
                res = res.replace(".0","")
                res = res.replace(",0","")
            }
            if(res.length == 4){
                res = res.replace(".00","")
                res = res.replace(",00","")
            }
            res = res.replace(".000","").replace(".0000","")
            res = res.replace(",000","").replace(",0000","")
        }else if(tp == "porcento"){
            if(res.length == 3){
                res = res.replace(".0","")
                res = res.replace(",0","")
            }
            if(res.length == 4){
                res = res.replace(".00","")
                res = res.replace(",00","")
            }
            res = res.replace(".000","").replace(".0000","")
            res = res.replace(",000","").replace(",0000","")
            if(res.length <= 0){
                res = "0"
            }
            res = res+"%"
        }
        return res;
    }

    return(<>
        
        { titulo.length > limit ? <Tooltip title={titulo}> 
        <div className={"btec-display-valor-box"} style={{width: width ? width : null, minWidth: minWidth ? minWidth : null,
             backgroundColor:fundo ? fundo : null, cursor:onClick ? "pointer" : "default"}} onClick={ onClick ? ()=> onClick() : null} > 
                {tag ? <> <div className={"btec-display-valor-tag"} style={estilo}></div></> : <></>}
                <div className={"btec-display-valor-content"} > 
                              
                    <div className={"btec-display-valor-titulo"} style={{display:"flex"}} > 
                            {titulo}
                            {help && String(help).length > 0 && <div><Tooltip title={String(help)} zIndex={999999}>
                                <FaQuestionCircle size={14} color={"rgb(69, 106, 121)"} style={{marginLeft:"5px"}}/></Tooltip></div> }
                    </div>
                    <div className={"btec-display-valor-valor"} >               
                            {trataT(String(valor), tipo)}
                    </div>
                 </div>

        </div>   
        </Tooltip>
        :        
        <div className={"btec-display-valor-box"} title={hint} style={{width: width ? width : null, minWidth: minWidth ? minWidth : null, overflow:"hidden", border: borda ? ("1px solid "+borda) : null, 
                    backgroundColor:fundo ? fundo : null, cursor:onClick ? "pointer" : "default"}} onClick={ onClick ? ()=> onClick() : null} >
        {tag ? <> <div className={"btec-display-valor-tag"} style={estilo}></div></> : <></>}
        <div className={"btec-display-valor-content"} > 
                     
           <div className={"btec-display-valor-titulo"} > 
                {titulo}
                {help && String(help).length > 0 && <div><Tooltip title={String(help)} zIndex={999999}>
                                <FaQuestionCircle size={14} color={"rgb(69, 106, 121)"} style={{marginLeft:"5px"}}/></Tooltip></div> }
           </div>
           <div className={"btec-display-valor-valor"} > 
                {trataT(String(valor), tipo)}
           </div>
        </div>
        </div>
        }
    </>)

}


export const BFiltroItem= ({tipo="", titulo ="", label="", txTipo="", def="", value, apply = () => {},  }) => {
    const [ prodDep, setProdDep ] = useState([]);//itens do combo
    const [ prodGrupos, setProdGrupos] = useState([]);//itens do combo
    const [ prodSubGrupos, setProdSubGrupos] = useState([]);//itens do combo

    const [ comboDep, setComboDep ] = useState("");//texto selecionado combo
    const [ comboGrupo, setComboGrupo ] = useState("");//texto selecionado combo
    const [ comboSubGrupo, setComboSubGrupo ] = useState("");//texto selecionado combo

    const [ cx_tags, setCx_tags ] = useState([]);

    function get_Id(itemNome){
        let res = -1;
        if(itemNome.length > 0){
     
            try{
                res = prodDep.filter(p => p.nome == itemNome)[0].id;
            }catch{
                res = -1;
            }
        }     
        return res; 
    }    

    function getNome(itemID){
        let res = "";
        if(itemID >= 0){
       
            try{
                res = prodDep.filter(p => p.id == itemID)[0].nome;
            }catch{
                res = "";
            }
        }     
        return res; 
    }   

    useEffect(() => {
        setCx_tags([]);

       
    }, []);  

    useEffect(() => {
     
    

      let depID = comboDep;
      let gruID =  comboGrupo;

          if (depID >= 0){
              setProdGrupos(prodDep.filter(p => p.tipo === 2 && p.aux == depID));
          }else{
              setProdGrupos([]); 
          }
          if (gruID >= 0){
              setProdSubGrupos(prodDep.filter(p => p.tipo === 3 && p.aux ==  gruID));   
          }else{
              setProdSubGrupos([]);
          } 

    }, [comboDep, comboGrupo]);  

    const estilo = {
       // backgroundColor: cor,
    }
 
    const [ vlr, setVlr ] = useState(def);

    return(
        <div className="box-filtros-lista-item-box" style={{ height : txTipo == "prod_grupo" ? "170px" : txTipo == "prod_sub_grupo" ? "230px" : "65px"}}>
            { safeStr(titulo).length > 0 && <div className="titulo">{ titulo }</div> }
            
            <div className="content" style={{display: txTipo == "prod_grupo" || txTipo == "prod_sub_grupo" ? "flex" : null  , 
                                             flexDirection: txTipo == "prod_grupo" || txTipo == "prod_sub_grupo" ? "column" : null, }}>
             { (txTipo == "texto" || txTipo == "tx" || txTipo == "text" || txTipo == "cod" || txTipo == "gtin") ? 
                    <><BEdit width={180} titulo={label} setValue={setVlr} value={vlr} /> </> 
                    : (txTipo == "qtd" || txTipo == "int") ?
                        <> <BNum width={180} titulo={label} setValue={setVlr} value={safeInt(vlr,0)} min={-99} max={9999} /> </> 
                        : (txTipo == "combo" || txTipo == "list") ? 
                            <> <BCombo width={180} titulo={label} setValue={setVlr} value={vlr} /></> 
                            : (txTipo == "valor" || txTipo == "float") ? 
                            <> <BValor width={180} titulo={label} setValue={setVlr} value={vlr} /> </> 
                            : (txTipo == "prod_dep") ? 
                            <> 
                            <BCombo2 width={"250px"} titulo={"Departamento"} setValue={setVlr} value={vlr}>
                                    {prodDep.filter(p => p.tipo === 1).map( (item) => { 
                                    return( <BComboOp value={item.id}>{item.nome}</BComboOp>)})}
                            </BCombo2>
                            </> 
                            : (txTipo == "tag_caixa") ? 
                            <> 
                            { cx_tags && cx_tags.length > 0 && <>
                            <BCombo2  width={"250px"} titulo={<div style={{ display:"flex", gap:"5px", alignItems:"center", 
                                                                            color:vlr >= 0 ?"white" :"black"}} >TAG</div>} 
                                            setValue={setVlr} value={vlr} cor={ vlr >= 0 ? (cx_tags.find(p => p.id == vlr) ? cx_tags.find(p => p.id == vlr).cor : "white") : "white" }>
                                        <BComboOp value={-1} style={{'backgroundColor':"white", color:"black"}}><p style={{color:"black"}}>(sem)</p></BComboOp>
                                            {cx_tags.map( (item) => { 
                                            return( <BComboOp value={item.id} style={{'backgroundColor':item.cor, color:"white"}}>
                                                <p style={{color:"white"}}>{item.nome}</p></BComboOp>) })}
                            </BCombo2>
                            </>}
                            </> 
                            : (txTipo == "prod_grupo") ? 
                            <> 
                            <BCombo2 width={"250px"} titulo={"Departamento"} setValue={setComboDep} value={comboDep}>
                                    {prodDep.filter(p => p.tipo === 1).map( (item) => { 
                                    return( <BComboOp value={item.id}>{item.nome}</BComboOp>)})}
                            </BCombo2>
                        
                            <BCombo2 titulo="Grupo" width={"250px"} setValue={setVlr} value={vlr}>
                                    {prodGrupos.filter(p => p.tipo === 2).map( (item) => { 
                                    return( <BComboOp value={item.id}>{item.nome}</BComboOp>)})}
                            </BCombo2>
                            </> 
                            : (txTipo == "prod_sub_grupo") ? 
                            <> 
                            <BCombo2 width={"250px"} titulo={"Departamento"} setValue={setComboDep} value={comboDep}>
                                    {prodDep.filter(p => p.tipo === 1).map( (item) => { 
                                    return( <BComboOp value={item.id} >{item.nome}</BComboOp>)})}
                            </BCombo2>
                            
                            <BCombo2 titulo="Grupo" width={"250px"} setValue={setComboGrupo} value={comboGrupo}>
                                    {prodGrupos.filter(p => p.tipo === 2).map( (item) => { 
                                    return( <BComboOp value={item.id} >{item.nome}</BComboOp>)})}
                            </BCombo2>

                            <BCombo2 titulo="Sub Grupo" width={"250px"} setValue={setVlr} value={vlr}>
                                    {prodSubGrupos.filter(p => p.tipo === 3).map( (item) => { 
                                    return( <BComboOp value={item.id} >{item.nome}</BComboOp>)})} 
                            </BCombo2>
                            </> 
                            : (txTipo == "cadastro" || txTipo == "cad") && 
                            <></>}
                

                <Button type="primary" shape="circle" icon={<PlusOutlined />} size="small" onClick={ () => {
                 
                    if(txTipo == "qtd" || txTipo == "int"){
                        if(tipo.length == 3 && vlr > -99){ let tmp = vlr; setVlr(def); apply(tipo,tmp);  }
                    }else if(txTipo == "prod_dep" || txTipo == "prod_grupo" || txTipo == "prod_sub_grupo"){ 
                        
                        if(tipo.length == 3 && vlr > 0){ apply(tipo, getNome(vlr)+"#|#"+String(vlr)); setVlr(def); }
                    }else if(txTipo == "cadastro"){ 
                        if(!isObjectEmpty(vlr)){
                            apply(tipo,vlr.nome+"#|#"+String(vlr.id)); setVlr(def); 
                        }
                    }else if(txTipo == "tag_caixa"){ 
                        if(safeInt(vlr,-1) >= 0){
                            apply(tipo, cx_tags.find(p => p.id == vlr).nome+"#|#"+String(vlr)); setVlr(def); 
                        }
                    }else{
                    
                         if(tipo.length == 3 && String(vlr).length > 0){  apply(tipo, vlr); setVlr(def); }
                    }
                }} />
            </div>              
        </div>
    )
}

export const BSelecter = ({name="", carregando=false, autoFoco=false, selected=-1, itens=[], onClick=() => {}}) => {
    const [ sel, setSel ] = useState(selected);//texto selecionado combo
    // itens={[ { titulo:"Retira na loja", id:1 }, { titulo:"Enviar para Cliente", id:2 } ]}
    return(<>
        <button name={name} style={{margin: 0, padding: 0, border: "none"}}
            className={`selecter_content ${ autoFoco && 'selecter_borda' } `} 
            onKeyUp={(e)=>{
                //toast.success(e.key)
                if(e.key == "ArrowDown"){
                    e.preventDefault();
                    setSel(sel + 1)
                }
                if(e.key == "ArrowUp"){
                    e.preventDefault();
                    setSel(sel - 1)
                }
                if(e.key == "Enter" || e.key == "Next" || e.key == "Go" || e.key == "Okay" || e.key == "Ok" ){
                    e.preventDefault();
                    let item = itens.find( p => p.id == sel);
                    if(item){
                       onClick(sel, item)
                    }
                    
                }
            }} >
            <Spin style={{'height':'100%'}} spinning={carregando} tip="Carregando...">
                { itens.map( e => { if(isObjectEmpty(e) == false){ return(
                    <div className={`selecter_btn selecter_bottom ${ sel == e.id && 'selecter_selected' } `} 
                            onClick={ () => {setSel(e.id); onClick(e.id, e)}} >
                        <div className="selecter_titulo">
                             {e.titulo && e.titulo}
                             {e.nome && e.nome}
                             {e.icon && e.icon}
                        </div>
                    </div>  
                )} }) }
            </Spin>
        </button>
    </>)
}


